/**
 * Bouquet Builder V2 — Wizard Logic
 * IIFE — all state and logic scoped to this section instance.
 */
(function () {
  'use strict';

  // ================================================================
  // CONSTANTS
  // ================================================================

  const AVATARS = [
    { id: 'bouquet-delivery', icon: '\uD83D\uDC90', label: 'Fresh Bouquet', desc: 'A beautiful hand-tied arrangement' },
    { id: 'wedding',          icon: '\uD83D\uDC92', label: 'Wedding',       desc: 'Bridal, bridesmaids, boutonnieres & more' },
    { id: 'sympathy',         icon: '\uD83D\uDD4A\uFE0F', label: 'Sympathy',      desc: 'Sprays, wreaths, tributes & casket pieces' },
    { id: 'corporate',        icon: '\uD83C\uDFE2', label: 'Corporate',    desc: 'Professional displays & arrangements' },
    { id: 'gift',             icon: '\uD83C\uDF81', label: 'Gift',         desc: 'Something special for someone special' },
    { id: 'subscription',     icon: '\uD83D\uDD04', label: 'Subscription', desc: 'Recurring fresh flowers' }
  ];

  const AVATAR_ARRANGEMENTS = {
    'wedding':          ['bridal-bouquet','bridesmaid-bouquet','boutonniere','corsage','hair-comb','flower-crown','centerpiece','garland'],
    'sympathy':         ['standing-spray','wreath','tribute','casket-spray','sympathy-bouquet'],
    'bouquet-delivery': ['bouquet','centerpiece'],
    'corporate':        ['bouquet','centerpiece'],
    'gift':             ['bouquet','centerpiece'],
    'subscription':     ['bouquet']
  };

  const ARRANGEMENT_META = {
    'bridal-bouquet':    { icon: '\uD83D\uDC90', label: 'Bridal Bouquet' },
    'bridesmaid-bouquet':{ icon: '\uD83C\uDF38', label: 'Bridesmaid Bouquet' },
    'boutonniere':       { icon: '\uD83C\uDF3C', label: 'Boutonniere' },
    'corsage':           { icon: '\uD83C\uDF3A', label: 'Corsage' },
    'hair-comb':         { icon: '\u2728',       label: 'Hair Comb' },
    'flower-crown':      { icon: '\uD83D\uDC51', label: 'Flower Crown' },
    'centerpiece':       { icon: '\uD83C\uDF3B', label: 'Centerpiece' },
    'garland':           { icon: '\uD83C\uDF3F', label: 'Garland / Arch' },
    'bouquet':           { icon: '\uD83D\uDC90', label: 'Bouquet' },
    'standing-spray':    { icon: '\uD83C\uDF3E', label: 'Standing Spray' },
    'wreath':            { icon: '\u2B55',       label: 'Wreath' },
    'tribute':           { icon: '\u2764\uFE0F', label: 'Heart/Cross Tribute' },
    'casket-spray':      { icon: '\uD83C\uDF39', label: 'Casket Spray' },
    'sympathy-bouquet':  { icon: '\uD83E\uDEB7', label: 'Sympathy Bouquet' }
  };

  const PACK_SIZES = {
    bouquet: {
      micro:   { total: [5,8],   focal: [2,4],   filler: [1,3],  greenery: [1,2] },
      petite:  { total: [10,15], focal: [5,8],   filler: [3,5],  greenery: [2,3] },
      classic: { total: [18,24], focal: [9,12],  filler: [6,8],  greenery: [3,4] },
      lush:    { total: [30,36], focal: [15,18], filler: [10,12],greenery: [5,6] },
      grand:   { total: [45,60], focal: [23,30], filler: [15,20],greenery: [7,10] }
    },
    'bridal-bouquet':    { petite: { total:[12,18], focal:[6,9],  filler:[4,6], greenery:[2,3] },
                           classic: { total:[20,28], focal:[10,14],filler:[7,9], greenery:[3,5] },
                           lush:    { total:[32,42], focal:[16,21],filler:[11,14],greenery:[5,7] } },
    'bridesmaid-bouquet':{ petite: { total:[8,12],  focal:[4,6],  filler:[2,4], greenery:[2,2] },
                           classic: { total:[14,20], focal:[7,10], filler:[5,7], greenery:[2,3] } },
    'standing-spray':    { small:   { total:[24,30], focal:[12,15],filler:[8,10],greenery:[4,5] },
                           classic: { total:[36,48], focal:[18,24],filler:[12,16],greenery:[6,8] },
                           lush:    { total:[50,65], focal:[25,33],filler:[17,22],greenery:[8,10] } },
    wreath:              { '14': { total:[20,26], focal:[10,13],filler:[7,9], greenery:[3,4] },
                           '18': { total:[28,36], focal:[14,18],filler:[9,12],greenery:[5,6] },
                           '24': { total:[38,50], focal:[19,25],filler:[13,17],greenery:[6,8] } },
    tribute:             { '18-20': { total:[24,32], focal:[12,16],filler:[8,11],greenery:[4,5] },
                           '22-24': { total:[32,42], focal:[16,21],filler:[11,14],greenery:[5,7] },
                           '28-30': { total:[42,55], focal:[21,28],filler:[14,18],greenery:[7,9] } },
    'casket-spray':      { half: { total:[40,55], focal:[20,28],filler:[13,18],greenery:[7,9] },
                           full: { total:[65,90], focal:[33,45],filler:[22,30],greenery:[10,15] } },
    boutonniere:         { default: { total:[3,3],  focal:[1,1], filler:[1,1], greenery:[1,1] } },
    corsage:             { default: { total:[3,6],  focal:[2,3], filler:[1,2], greenery:[1,2] } },
    'hair-comb':         { default: { total:[3,5],  focal:[2,3], filler:[1,1], greenery:[0,1] } },
    'flower-crown':      { default: { total:[12,20],focal:[6,10],filler:[4,7], greenery:[2,3] } },
    centerpiece:         { petite:  { total:[10,15],focal:[5,8], filler:[3,5], greenery:[2,3] },
                           classic: { total:[18,24],focal:[9,12],filler:[6,8], greenery:[3,4] },
                           lush:    { total:[28,36],focal:[14,18],filler:[9,12],greenery:[5,6] } },
    garland:             { /* calculated per foot */ },
    'sympathy-bouquet':  { petite:  { total:[10,15],focal:[5,8], filler:[3,5], greenery:[2,3] },
                           classic: { total:[18,24],focal:[9,12],filler:[6,8], greenery:[3,4] },
                           lush:    { total:[30,36],focal:[15,18],filler:[10,12],greenery:[5,6] } }
  };

  // Garland: stems per foot at each density
  const GARLAND_PER_FOOT = { light: 4, medium: 6, lush: 9 };

  const DENSITY_MULT = { airy: 0.85, classic: 1.0, lush: 1.25 };

  const SIZE_OPTIONS = {
    bouquet:             [{ id:'micro',label:'Micro',stems:'5-8'},{id:'petite',label:'Petite',stems:'10-15'},{id:'classic',label:'Classic',stems:'18-24'},{id:'lush',label:'Lush',stems:'30-36'},{id:'grand',label:'Grand',stems:'45-60'}],
    'bridal-bouquet':    [{id:'petite',label:'Petite',stems:'12-18'},{id:'classic',label:'Classic',stems:'20-28'},{id:'lush',label:'Lush',stems:'32-42'}],
    'bridesmaid-bouquet':[{id:'petite',label:'Petite',stems:'8-12'},{id:'classic',label:'Classic',stems:'14-20'}],
    'standing-spray':    [{id:'small',label:'Small 24-28"',stems:'24-30'},{id:'classic',label:'Classic 30-36"',stems:'36-48'},{id:'lush',label:'Lush 40-48"',stems:'50-65'}],
    wreath:              [{id:'14',label:'14"',stems:'20-26'},{id:'18',label:'18"',stems:'28-36'},{id:'24',label:'24"',stems:'38-50'}],
    tribute:             [{id:'18-20',label:'18-20"',stems:'24-32'},{id:'22-24',label:'22-24"',stems:'32-42'},{id:'28-30',label:'28-30"',stems:'42-55'}],
    'casket-spray':      [{id:'half',label:'Half Couch',stems:'40-55'},{id:'full',label:'Full Couch',stems:'65-90'}],
    boutonniere:         [{id:'default',label:'Standard',stems:'3'}],
    corsage:             [{id:'default',label:'Standard',stems:'3-6'}],
    'hair-comb':         [{id:'default',label:'Standard',stems:'3-5'}],
    'flower-crown':      [{id:'default',label:'Standard',stems:'12-20'}],
    centerpiece:         [{id:'petite',label:'Petite',stems:'10-15'},{id:'classic',label:'Classic',stems:'18-24'},{id:'lush',label:'Lush',stems:'28-36'}],
    garland:             [], // special: length + density
    'sympathy-bouquet':  [{id:'petite',label:'Petite',stems:'10-15'},{id:'classic',label:'Classic',stems:'18-24'},{id:'lush',label:'Lush',stems:'30-36'}]
  };

  // HPS defaults (heads per stem) for multi-bloom stems
  const HPS_DEFAULTS = {
    'spray-rose': 3.5, 'alstroemeria': 3, 'spray-mum': 6,
    'waxflower': 2, 'babys-breath': 2, 'limonium': 2,
    'spray-carnation': 4, 'lisianthus': 3, 'aster': 3
  };

  // Package variant mapping (arrangement_type|service_level -> Shopify variant data)
  // This gets populated from the product JSON at init
  const PACKAGE_PRICE_MATRIX = {
    'circular|petite':   5000 * 0, // $0
    'circular|allin':    5000,     // $50
    'circular|asap':     10000,    // $100
    'standing|petite':   5000,
    'standing|allin':    8500,
    'standing|asap':     20000,
    'wreath|petite':     0,
    'wreath|allin':      8500,
    'wreath|asap':       20000,
    'casket|petite':     5000,
    'casket|allin':      10000,
    'casket|asap':       20000,
    'tribute|petite':    5000,
    'tribute|allin':     8500,
    'tribute|asap':      20000,
    'garland|petite':    10000,
    'garland|allin':     15000,
    'garland|asap':      20000,
    'wearable|petite':   500,
    'wearable|allin':    5000,
    'wearable|asap':     15000
  };

  // Map arrangement types to package categories
  const ARRANGEMENT_TO_PACKAGE = {
    'bouquet': 'circular', 'bridal-bouquet': 'circular', 'bridesmaid-bouquet': 'circular',
    'sympathy-bouquet': 'circular', 'centerpiece': 'circular',
    'standing-spray': 'standing',
    'wreath': 'wreath',
    'casket-spray': 'casket',
    'tribute': 'tribute',
    'garland': 'garland',
    'boutonniere': 'wearable', 'corsage': 'wearable', 'hair-comb': 'wearable', 'flower-crown': 'wearable'
  };

  const SERVICE_LEVELS = [
    { id: 'petite', label: 'Petite / DIY', desc: 'You arrange it! Includes free how-to guides, tool tips, and support.',
      perks: 'Step-by-step video guides, BYOB tool access, Pack Size Builder, direct support' },
    { id: 'allin',  label: 'All-In & Beautiful', desc: 'We design & arrange it for you. Professional florist assembly.',
      perks: 'Professional arrangement, custom design, premium finishing' },
    { id: 'asap',   label: 'All-In ASAP', desc: 'Professional assembly + rush processing. Need it fast? We got you.',
      perks: 'Rush processing, priority handling, professional arrangement' }
  ];

  const PALETTE_STYLES = [
    { id: 'monochromatic', label: 'Monochromatic', desc: 'Elegant shades of one color',
      swatches: ['#f8b4c8','#f19cbb','#e880a8','#d6678f'] },
    { id: 'analogous', label: 'Analogous', desc: 'Neighboring colors, harmonious',
      swatches: ['#f8b4c8','#f4a679','#f7c948','#fce4b8'] },
    { id: 'complementary', label: 'Complementary', desc: 'Contrasting, bold & eye-catching',
      swatches: ['#9b59b6','#f1c40f','#8e44ad','#f39c12'] },
    { id: 'wild-mix', label: 'Wild Mix', desc: 'Garden-gathered, eclectic & joyful',
      swatches: ['#e74c3c','#f39c12','#9b59b6','#3498db'] }
  ];

  const COLOR_FAMILIES = [
    { id: 'white',    label: 'White',    color: '#f5f0eb' },
    { id: 'ivory',    label: 'Ivory',    color: '#fffff0' },
    { id: 'peach',    label: 'Peach',    color: '#ffcba4' },
    { id: 'coral',    label: 'Coral',    color: '#f0736e' },
    { id: 'pink',     label: 'Pink',     color: '#f8b4c8' },
    { id: 'hot pink', label: 'Hot Pink', color: '#ff69b4' },
    { id: 'red',      label: 'Red',      color: '#c0392b' },
    { id: 'burgundy', label: 'Burgundy', color: '#800020' },
    { id: 'orange',   label: 'Orange',   color: '#e67e22' },
    { id: 'yellow',   label: 'Yellow',   color: '#f1c40f' },
    { id: 'gold',     label: 'Gold',     color: '#d4a017' },
    { id: 'lavender', label: 'Lavender', color: '#b57edc' },
    { id: 'purple',   label: 'Purple',   color: '#8e44ad' },
    { id: 'blue',     label: 'Blue',     color: '#3498db' },
    { id: 'green',    label: 'Green',    color: '#27ae60' }
  ];

  // Preferred color families per palette style (first match wins)
  const PALETTE_COLOR_PREFS = {
    'monochromatic': [],          // uses state.colorFamily directly
    'analogous':     ['pink','peach','coral','orange','yellow','gold','hot pink','red'],
    'complementary': ['purple','lavender','yellow','gold','red','burgundy','orange'],
    'wild-mix':      ['red','orange','purple','blue','pink','coral','yellow','hot pink','lavender','burgundy','gold','peach']
  };

  // ================================================================
  // INIT: Find section root & load config
  // ================================================================

  // Find the section root — look for any .pp-builder-v2 on the page
  const roots = document.querySelectorAll('.pp-builder-v2');
  roots.forEach(function (root) {
    if (root.dataset.ppInit === '1') return;
    root.dataset.ppInit = '1';
    initBuilder(root);
  });

  function initBuilder(root) {
    const sectionId = root.id.replace('pp-', '');
    const configEl = document.getElementById('ppConfig-' + sectionId);
    if (!configEl) return;

    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

    var settings = config.settings || {};

    // ================================================================
    // HELPERS
    // ================================================================
    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.from(root.querySelectorAll(sel)); };
    var money = function (cents) {
      var v = parseInt(cents || 0, 10) / 100;
      return v.toLocaleString(undefined, { style: 'currency', currency: 'USD' });
    };
    var dayName = function (d) {
      return ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'][d.getDay()];
    };

    function hhmm(base, t) {
      var s = String(t || '').trim().toUpperCase();
      var m = s.match(/^(\d{1,2}):(\d{2})(?:\s*(AM|PM))?$/);
      var d = new Date(base);
      if (!m) { d.setHours(12,0,0,0); return d; }
      var h = parseInt(m[1],10), min = parseInt(m[2],10), ap = m[3];
      if (ap) { if (h === 12) h = 0; if (ap === 'PM') h += 12; }
      d.setHours(h, min, 0, 0);
      return d;
    }

    function to24hRange(label) {
      if (!label) return '';
      function one(s) {
        var m = String(s||'').trim().match(/^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)?$/i);
        if (!m) return null;
        var h = parseInt(m[1],10), min = parseInt(m[2]||'0',10), ap = (m[3]||'').toUpperCase();
        if (ap) { if (h===12) h=0; if (ap==='PM') h+=12; }
        return String(h).padStart(2,'0')+':'+String(min).padStart(2,'0');
      }
      var parts = String(label).split('-');
      var s = one(parts[0]), e = one(parts[1]);
      return (s && e) ? s+' - '+e : '';
    }

    function buildBuuntoSignature(isoDate, timeLabel) {
      var r24 = to24hRange(timeLabel || '');
      if (!isoDate || !r24) return '';
      return 'SHIPPING|'+isoDate+'|'+r24+'|'+settings.buuntoMethod;
    }

    function htmlDecode(s) {
      var t = document.createElement('textarea');
      t.innerHTML = s || '';
      return t.value;
    }

    // ================================================================
    // STATE
    // ================================================================
    var state = {
      avatar: settings.showAvatarStep ? null : settings.defaultAvatar,
      arrangements: [],      // [{type, qty, size, density, serviceLevel}]
      bridesmaids: 0,
      groomsmen: 0,
      paletteStyle: null,
      colorFamily: null,
      currentStep: 0,
      selections: [],        // [{handle, collection, role, variantId, variantTitle, priceCents, qty, title, image}]
      packageVariants: {},   // loaded from product JSON
      packageProduct: null
    };

    // Step definitions: built dynamically
    var stepDefs = buildStepDefs();

    function buildStepDefs() {
      var defs = [];
      if (settings.showAvatarStep) defs.push({ id: 'avatar', label: 'Occasion' });
      defs.push({ id: 'arrangements', label: 'Arrangements' });
      defs.push({ id: 'size', label: 'Size & Density' });
      defs.push({ id: 'service', label: 'Service Level' });
      defs.push({ id: 'color', label: 'Color & Style' });
      // collection steps
      var colSteps = qa('.pp-v2-collection-step');
      colSteps.forEach(function (el, i) {
        var title = el.querySelector('.pp-v2-collection-title');
        defs.push({ id: 'collection-' + i, label: title ? title.textContent.trim() : 'Step ' + (defs.length + 1) });
      });
      defs.push({ id: 'review', label: 'Review & Checkout' });
      return defs;
    }

    // ================================================================
    // MILESTONE / GRAND SLAM TIERS
    // ================================================================
    var rawTiers = [
      { threshold: Number(settings.tier1Threshold) || 0, label: settings.tier1Label || '' },
      { threshold: Number(settings.tier2Threshold) || 0, label: settings.tier2Label || '' },
      { threshold: Number(settings.tier3Threshold) || 0, label: settings.tier3Label || '' }
    ].filter(function (t) { return t.threshold > 0 && t.label.trim() !== ''; });

    var TIERS = rawTiers.map(function (t) {
      return { cents: Math.round(t.threshold * 100), label: t.label.trim() };
    }).sort(function (a, b) { return a.cents - b.cents; });

    function milestoneState(subtotalCents) {
      if (!TIERS.length) {
        var tc = Math.round((settings.freeShipThreshold || 35) * 100);
        var rem = Math.max(0, tc - subtotalCents);
        return {
          unlocked: subtotalCents >= tc ? [{ cents: tc, label: 'free shipping' }] : [],
          next: subtotalCents >= tc ? null : { cents: tc, label: 'free shipping' },
          remaining: rem
        };
      }
      return {
        unlocked: TIERS.filter(function (t) { return subtotalCents >= t.cents; }),
        next: TIERS.find(function (t) { return subtotalCents < t.cents; }) || null,
        remaining: (function () {
          var n = TIERS.find(function (t) { return subtotalCents < t.cents; });
          return n ? Math.max(0, n.cents - subtotalCents) : 0;
        })()
      };
    }

    function milestoneCopy(subtotalCents) {
      var ms = milestoneState(subtotalCents);
      if (ms.next) return money(ms.remaining) + ' away from ' + ms.next.label;
      var top = ms.unlocked[ms.unlocked.length - 1];
      if (!top) return '';
      var isFree = top.label.toLowerCase().indexOf('free') >= 0;
      return isFree
        ? "You've unlocked " + top.label + '! - On time delivery, or they are FREE!'
        : "You've unlocked " + top.label + '!';
    }

    // ================================================================
    // URGENCY CLOCK
    // ================================================================
    var clockEl = q('#ppClock-' + sectionId);
    var nextEl = q('#ppNextDay-' + sectionId);
    var nextAvailableText = '';

    function tick() {
      var now = new Date();
      var target = hhmm(now, settings.cutoffTimeStr);
      if (now > target) target.setDate(target.getDate() + 1);
      var diff = target - now;
      var h = Math.max(0, Math.floor(diff / 3600000));
      var m = Math.max(0, Math.floor((diff % 3600000) / 60000));
      var s = Math.max(0, Math.floor((diff % 60000) / 1000));
      if (clockEl) clockEl.textContent = String(h).padStart(2,'0')+':'+String(m).padStart(2,'0')+':'+String(s).padStart(2,'0');
      var passed = now > hhmm(now, settings.cutoffTimeStr);
      if (nextEl) {
        nextEl.textContent = (passed && nextAvailableText) ? '\u00B7 Order now for ' + nextAvailableText : '';
      }
    }
    setInterval(tick, 1000);
    tick();

    // ================================================================
    // BUUNTO DATE HOOKING
    // ================================================================
    var dateSum = q('#ppDateSummary-' + sectionId);
    var chip = q('#ppShipChip-' + sectionId);
    var shipDateInput = q('#ppShipDate-' + sectionId);
    var shipDayInput = q('#ppShipDay-' + sectionId);

    function setShip(dateStr) {
      if (!dateStr) {
        if (dateSum) dateSum.textContent = 'Not selected';
        if (chip) chip.textContent = 'No date';
        return;
      }
      var d = new Date(dateStr + 'T00:00:00');
      var nice = dayName(d) + ', ' + d.toLocaleDateString();
      if (dateSum) dateSum.textContent = nice;
      if (chip) chip.textContent = nice;
      if (shipDateInput) shipDateInput.value = dateStr;
      if (shipDayInput) shipDayInput.value = dayName(d);
      var t = q('#ppDrawerDate-' + sectionId);
      if (t) t.textContent = nice;
    }

    window.addEventListener('buunto:date-selected', function (e) {
      if (!e || !e.detail || !e.detail.date) return;
      setShip(e.detail.date);
      nextAvailableText = new Date(e.detail.date + 'T00:00:00').toLocaleDateString(undefined, { weekday: 'long' });
    });

    if (settings.useBuunto && settings.buuntoSelector) {
      var bTarget = document.querySelector(settings.buuntoSelector);
      if (bTarget) {
        var applyBuunto = function () {
          var val = bTarget.value || bTarget.getAttribute('value') || '';
          if (val) {
            setShip(val);
            nextAvailableText = new Date(val + 'T00:00:00').toLocaleDateString(undefined, { weekday: 'long' });
            var timeVal = (q('#ppShipTime-'+sectionId) || {}).value ||
              (document.querySelector('#buunto-time') || {}).value || '';
            var sig = buildBuuntoSignature(val, timeVal);
            var sigEl = q('#ppBuuntoSig-' + sectionId);
            if (sigEl) sigEl.value = sig;
            try { updateSlotChip(); } catch (_) {}
          }
        };
        applyBuunto();
        var bObs = new MutationObserver(applyBuunto);
        bObs.observe(bTarget, { attributes: true, attributeFilter: ['value'] });
        bTarget.addEventListener('input', applyBuunto);
        bTarget.addEventListener('change', applyBuunto);
      }
    }

    // ================================================================
    // SLOT CHIP (Buunto availability)
    // ================================================================
    var SLOT_LOW_THRESHOLD = 3;

    function isPlaceholderOption(opt) {
      if (!opt) return true;
      var t = (opt.textContent || '').toLowerCase();
      var v = (opt.value || '').toLowerCase();
      return opt.disabled || !v || /select|choose|pick/.test(t);
    }

    function parseSlotsLeftFromOption(opt) {
      if (!opt) return null;
      var attrs = ['data-left','data-remaining','data-available','data-availability','data-available-slots',
        'data-slots-left','data-slots','data-qty','data-qty-left','data-available-count'];
      var attrNum = null;
      for (var i = 0; i < attrs.length; i++) {
        var raw = opt.getAttribute && opt.getAttribute(attrs[i]);
        if (raw != null && String(raw).trim() !== '') {
          var n = Number(String(raw).trim());
          if (Number.isFinite(n)) { attrNum = n; break; }
        }
      }
      var txt = (opt.getAttribute && opt.getAttribute('data-label') || opt.textContent || '').trim();
      var m = txt.match(/(\d+)\s*(?:left|remaining|slots?)/i);
      var textNum = m ? Number(m[1]) : null;
      if (Number.isFinite(textNum) && (!Number.isFinite(attrNum) || attrNum <= 0)) return textNum;
      return Number.isFinite(attrNum) ? attrNum : null;
    }

    function niceSlotText() {
      var dateStr = (q('#ppShipDate-'+sectionId) || {}).value || '';
      var timeLabel = (q('#ppShipTime-'+sectionId) || {}).value || '';
      if (!dateStr) return '';
      var d = new Date(dateStr + 'T00:00:00');
      return timeLabel ? dayName(d) + ' \u00B7 ' + timeLabel : dayName(d);
    }

    function slotLeft() {
      var el = q('#ppBuuntoLeft-' + sectionId);
      if (!el) return null;
      var s = String(el.value || '').trim();
      if (s === '') return null;
      var n = Number(s);
      return Number.isFinite(n) ? n : null;
    }

    function dayLeft() {
      var el = q('#ppBuuntoDayLeft-' + sectionId);
      if (!el) return null;
      var s = String(el.value || '').trim();
      if (s === '') return null;
      var n = Number(s);
      return Number.isFinite(n) ? n : null;
    }

    function updateSlotChip() {
      var slotChipEl = q('#ppSlotChip-' + sectionId);
      var slotTextEl = q('#ppSlotText-' + sectionId);
      if (!slotChipEl || !slotTextEl) return;
      var msg = niceSlotText();
      var leftDaily = dayLeft();
      var leftSlot = slotLeft();
      slotChipEl.hidden = !settings.useBuunto;
      if (!settings.useBuunto) return;
      if (!msg) {
        slotChipEl.classList.add('is-empty');
        slotChipEl.classList.remove('low');
        slotTextEl.textContent = 'Choose a delivery window';
        return;
      }
      slotChipEl.classList.remove('is-empty');
      var label = msg, leftShown = null;
      if (typeof leftDaily === 'number' && leftDaily >= 0) {
        leftShown = leftDaily;
        label += ' \u00B7 ' + leftDaily + ' left today';
      } else if (typeof leftSlot === 'number' && leftSlot >= 0) {
        leftShown = leftSlot;
        label += ' \u00B7 ' + leftSlot + ' left';
      }
      slotChipEl.classList.toggle('low', leftShown !== null && leftShown <= SLOT_LOW_THRESHOLD);
      slotTextEl.textContent = label;
    }

    // ================================================================
    // STEP NAVIGATION
    // ================================================================
    var prevBtn = q('#ppPrev-' + sectionId);
    var nextBtn = q('#ppNext-' + sectionId);
    var stepFill = q('#ppStepFill-' + sectionId);
    var stepLabel = q('#ppStepLabel-' + sectionId);
    var miniDots = q('#ppMini-' + sectionId);

    function rebuildMiniDots() {
      if (!miniDots) return;
      miniDots.innerHTML = '';
      stepDefs.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'pp-v2-stepdot';
        dot.dataset.i = String(i);
        dot.addEventListener('click', function () { showStep(i); });
        miniDots.appendChild(dot);
      });
    }
    rebuildMiniDots();

    // Set CSS variable for stepper bar segments
    var stepper = q('#ppStepper-' + sectionId);
    if (stepper) stepper.style.setProperty('--pp-total-steps', String(stepDefs.length));

    function showStep(i) {
      state.currentStep = Math.max(0, Math.min(i, stepDefs.length - 1));
      var def = stepDefs[state.currentStep];

      // Hide all steps, show the active one
      qa('.pp-v2-step').forEach(function (el) { el.classList.remove('is-active'); });
      var activeEl = q('[data-step="' + def.id + '"]');
      if (activeEl) activeEl.classList.add('is-active');

      // Progress bar
      if (stepFill) stepFill.style.width = ((state.currentStep + 1) / stepDefs.length * 100) + '%';

      // Label
      if (stepLabel) stepLabel.textContent = 'Step ' + (state.currentStep + 1) + ' of ' + stepDefs.length + ' \u2014 ' + def.label;

      // Mini dots with collection count badges
      if (miniDots) {
        miniDots.querySelectorAll('.pp-v2-stepdot').forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === state.currentStep);
          d.classList.toggle('is-done', idx < state.currentStep);
          // Badge for collection steps with existing selections
          var badge = d.querySelector('.pp-v2-stepdot-badge');
          var sDef = stepDefs[idx];
          if (sDef && sDef.id.indexOf('collection-') === 0) {
            var stepEl = q('[data-step="' + sDef.id + '"]');
            var role = stepEl ? stepEl.dataset.role : '';
            var count = role ? selectionsInRole(role) : 0;
            if (count > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'pp-v2-stepdot-badge';
                d.appendChild(badge);
              }
              badge.textContent = String(count);
            } else if (badge) {
              badge.remove();
            }
          } else if (badge) {
            badge.remove();
          }
        });
      }

      // Button states (stepper bar)
      if (prevBtn) prevBtn.style.display = state.currentStep === 0 ? 'none' : '';
      if (nextBtn) {
        if (def.id === 'review') {
          nextBtn.style.display = 'none';
        } else {
          nextBtn.style.display = '';
          nextBtn.textContent = state.currentStep === stepDefs.length - 2 ? 'Review' : 'Next';
        }
      }

      // Button states (sticky footer)
      if (footerPrev) footerPrev.style.display = state.currentStep === 0 ? 'none' : '';
      if (footerNext) {
        if (def.id === 'review') {
          footerNext.style.display = 'none';
        } else {
          footerNext.style.display = '';
          footerNext.textContent = state.currentStep === stepDefs.length - 2 ? 'Review' : 'Next';
        }
      }

      // Scroll to stepper (not the section heading)
      var scrollTarget = stepper || root;
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Trigger step-specific rendering
      if (def.id === 'arrangements') renderArrangements();
      if (def.id === 'size') renderSizeStep();
      if (def.id === 'service') renderServiceStep();
      if (def.id === 'color') renderColorStep();
      if (def.id === 'review') renderReview();
      if (def.id.indexOf('collection-') === 0) {
        autoSwapVariants(activeEl);
        softSortCollection(activeEl);
        updateTally(activeEl);
        updateCompositionBar();
        renderArrangementSummary();
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { showStep(state.currentStep - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showStep(state.currentStep + 1); });

    // Bottom nav buttons in collection steps
    qa('.pp-prev--bottom').forEach(function (b) {
      b.addEventListener('click', function () { showStep(state.currentStep - 1); });
    });
    qa('.pp-next--bottom').forEach(function (b) {
      b.addEventListener('click', function () { showStep(state.currentStep + 1); });
    });
    qa('.pp-skip').forEach(function (b) {
      b.addEventListener('click', function () { showStep(state.currentStep + 1); });
    });

    // Footer nav buttons
    var footerPrev = q('#ppFooterPrev-' + sectionId);
    var footerNext = q('#ppFooterNext-' + sectionId);
    if (footerPrev) footerPrev.addEventListener('click', function () { showStep(state.currentStep - 1); });
    if (footerNext) footerNext.addEventListener('click', function () {
      var def = stepDefs[state.currentStep];
      if (def && def.id === 'review') return; // already on review
      showStep(state.currentStep + 1);
    });

    // ================================================================
    // STEP 0: AVATAR SELECTION
    // ================================================================
    function renderAvatars() {
      var grid = q('#ppAvatarGrid-' + sectionId);
      if (!grid) return;
      grid.innerHTML = '';
      AVATARS.forEach(function (av) {
        var card = document.createElement('div');
        card.className = 'pp-v2-avatar-card';
        card.dataset.avatar = av.id;
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        card.setAttribute('aria-label', av.label);
        card.innerHTML =
          '<span class="pp-v2-avatar-icon">' + av.icon + '</span>' +
          '<div class="pp-v2-avatar-label">' + av.label + '</div>' +
          '<div class="pp-v2-avatar-desc">' + av.desc + '</div>';
        card.addEventListener('click', function () { selectAvatar(av.id); });
        card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectAvatar(av.id); } });
        grid.appendChild(card);
      });
    }

    function selectAvatar(id) {
      state.avatar = id;
      state.arrangements = [];
      // Update visual
      qa('.pp-v2-avatar-card').forEach(function (c) {
        c.classList.toggle('is-selected', c.dataset.avatar === id);
      });
      // Auto-advance after short delay
      setTimeout(function () { showStep(state.currentStep + 1); }, 300);
    }

    if (settings.showAvatarStep) renderAvatars();

    // ================================================================
    // STEP 1: ARRANGEMENT TYPES
    // ================================================================
    function renderArrangements() {
      var grid = q('#ppArrangementGrid-' + sectionId);
      if (!grid) return;
      grid.innerHTML = '';
      var avatar = state.avatar || settings.defaultAvatar;
      var types = AVATAR_ARRANGEMENTS[avatar] || AVATAR_ARRANGEMENTS['bouquet-delivery'];

      types.forEach(function (type) {
        var meta = ARRANGEMENT_META[type] || { icon: '\uD83C\uDF3C', label: type };
        var card = document.createElement('div');
        card.className = 'pp-v2-arrangement-card';
        card.dataset.type = type;
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        card.setAttribute('aria-pressed', 'false');
        // Check if already selected
        var existing = state.arrangements.find(function (a) { return a.type === type; });
        var isSelected = !!existing;
        if (isSelected) {
          card.classList.add('is-selected');
          card.setAttribute('aria-pressed', 'true');
        }
        card.innerHTML =
          '<span class="pp-v2-arrangement-icon">' + meta.icon + '</span>' +
          '<div class="pp-v2-arrangement-label">' + meta.label + '</div>' +
          '<div class="pp-v2-arr-qty' + (isSelected ? ' is-visible' : '') + '">' +
          '<button type="button" class="pp-v2-arr-qty-btn" data-arr-type="' + type + '" data-delta="-1" aria-label="Decrease">−</button>' +
          '<span class="pp-v2-arr-qty-val">' + (existing ? existing.qty : 1) + '</span>' +
          '<button type="button" class="pp-v2-arr-qty-btn" data-arr-type="' + type + '" data-delta="1" aria-label="Increase">+</button>' +
          '</div>';
        // Click on card body (not qty buttons) toggles selection
        card.addEventListener('click', function (e) {
          if (e.target.closest('.pp-v2-arr-qty-btn')) return;
          toggleArrangement(type);
        });
        card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleArrangement(type); } });
        grid.appendChild(card);
      });

      // Wedding party calculator
      var partyCalc = q('#ppPartyCalc-' + sectionId);
      if (partyCalc) partyCalc.hidden = avatar !== 'wedding';
      updatePartySummary();

      // Qty +/- delegation on arrangement grid
      if (!grid.__ppQtyBound) {
        grid.__ppQtyBound = true;
        grid.addEventListener('click', function (e) {
          var btn = e.target.closest('.pp-v2-arr-qty-btn');
          if (!btn) return;
          e.stopPropagation();
          var arrType = btn.dataset.arrType;
          var delta = parseInt(btn.dataset.delta, 10) || 0;
          var arr = state.arrangements.find(function (a) { return a.type === arrType; });
          if (!arr) return;
          arr.qty = Math.max(1, arr.qty + delta);
          // Sync perItem array length if customized
          if (arr.perItem) {
            while (arr.perItem.length < arr.qty) {
              arr.perItem.push({ size: arr.size, density: arr.density });
            }
            while (arr.perItem.length > arr.qty) {
              arr.perItem.pop();
            }
          }
          syncArrangementCards();
          renderSizeStep();
        });
      }
    }

    function toggleArrangement(type) {
      var idx = state.arrangements.findIndex(function (a) { return a.type === type; });
      if (idx >= 0) {
        state.arrangements.splice(idx, 1);
      } else {
        state.arrangements.push({ type: type, qty: 1, size: null, density: 'classic', serviceLevel: 'petite' });
      }
      syncArrangementCards();
      updatePartySummary();
    }

    function syncArrangementCards() {
      qa('.pp-v2-arrangement-card').forEach(function (c) {
        var t = c.dataset.type;
        var arr = state.arrangements.find(function (a) { return a.type === t; });
        var sel = !!arr;
        c.classList.toggle('is-selected', sel);
        c.setAttribute('aria-pressed', String(sel));
        var qtyWrap = c.querySelector('.pp-v2-arr-qty');
        if (qtyWrap) {
          qtyWrap.classList.toggle('is-visible', sel);
          var valEl = qtyWrap.querySelector('.pp-v2-arr-qty-val');
          if (valEl) valEl.textContent = arr ? arr.qty : 1;
        }
      });
    }

    // Wedding party calculator
    var bridesmaidsInput = q('#ppBridesmaids-' + sectionId);
    var groomsmenInput = q('#ppGroomsmen-' + sectionId);

    function updatePartySummary(skipAutoCalc) {
      var avatar = state.avatar || settings.defaultAvatar;
      if (avatar !== 'wedding') return;

      var bm = parseInt((bridesmaidsInput || {}).value || 0, 10) || 0;
      var gm = parseInt((groomsmenInput || {}).value || 0, 10) || 0;
      state.bridesmaids = bm;
      state.groomsmen = gm;

      if (!skipAutoCalc) {
        // Auto-build arrangements from party counts — no manual card clicking needed
        var autoTypes = [
          { type: 'bridal-bouquet', qty: 1 },
          { type: 'bridesmaid-bouquet', qty: bm },
          { type: 'boutonniere', qty: gm + 1 }, // +1 for groom
          { type: 'corsage', qty: bm > 0 ? 2 : 0 } // mothers typically
        ];

        autoTypes.forEach(function (at) {
          var existing = state.arrangements.find(function (a) { return a.type === at.type; });
          if (at.qty > 0 && !existing) {
            // Auto-add arrangement
            state.arrangements.push({ type: at.type, qty: at.qty, size: null, density: 'classic', serviceLevel: 'petite' });
          } else if (existing) {
            existing.qty = at.qty;
          }
        });

        // Remove auto-managed types that hit 0
        state.arrangements = state.arrangements.filter(function (a) {
          var isAutoManaged = autoTypes.some(function (at) { return at.type === a.type; });
          return !isAutoManaged || a.qty > 0;
        });

        // Sync arrangement card visuals
        qa('.pp-v2-arrangement-card').forEach(function (c) {
          var sel = state.arrangements.some(function (a) { return a.type === c.dataset.type; });
          c.classList.toggle('is-selected', sel);
          c.setAttribute('aria-pressed', String(sel));
        });
      }

      var summaryEl = q('#ppPartySummary-' + sectionId);
      if (!summaryEl) return;

      var html = '';
      state.arrangements.forEach(function (a, idx) {
        var meta = ARRANGEMENT_META[a.type] || { label: a.type };
        html += '<div class="pp-v2-party-item">'
          + '<span class="pp-v2-party-item-label">' + meta.label + '</span>'
          + '<div class="pp-v2-party-item-qty">'
          + '<button type="button" class="pp-v2-party-qty-btn" data-arr-idx="' + idx + '" data-delta="-1" aria-label="Decrease ' + meta.label + '">−</button>'
          + '<span class="pp-v2-party-qty-count">' + a.qty + '</span>'
          + '<button type="button" class="pp-v2-party-qty-btn" data-arr-idx="' + idx + '" data-delta="1" aria-label="Increase ' + meta.label + '">+</button>'
          + '</div>'
          + '</div>';
      });
      summaryEl.innerHTML = html;
    }

    // Delegate clicks on party summary +/− buttons
    var partySummaryEl = q('#ppPartySummary-' + sectionId);
    if (partySummaryEl) {
      partySummaryEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.pp-v2-party-qty-btn');
        if (!btn) return;
        var idx = parseInt(btn.dataset.arrIdx, 10);
        var delta = parseInt(btn.dataset.delta, 10);
        var arr = state.arrangements[idx];
        if (!arr) return;
        arr.qty = Math.max(0, arr.qty + delta);
        updatePartySummary(true); // re-render without overwriting manual edits
        renderSizeStep(); // refresh size step since arrangement qtys changed
      });
    }

    if (bridesmaidsInput) bridesmaidsInput.addEventListener('input', updatePartySummary);
    if (groomsmenInput) groomsmenInput.addEventListener('input', updatePartySummary);

    // ================================================================
    // STEP 2: SIZE & DENSITY
    // ================================================================
    // Render size/density picker for one sub-item
    function renderSizeDensityBlock(arr, arrIdx, subIdx, sizes, parentEl) {
      var itemSize = subIdx !== null && arr.perItem ? arr.perItem[subIdx].size : arr.size;
      var itemDensity = subIdx !== null && arr.perItem ? arr.perItem[subIdx].density : arr.density;

      if (arr.type === 'garland') {
        var garlandDiv = document.createElement('div');
        garlandDiv.innerHTML =
          '<div class="pp-v2-garland-input">' +
          '<input type="number" min="1" max="100" value="' + (arr.garlandFeet || 8) + '" data-arr="' + arrIdx + '" class="pp-v2-garland-feet">' +
          '<span>feet</span></div>';
        parentEl.appendChild(garlandDiv);
        garlandDiv.querySelector('input').addEventListener('input', function (e) {
          state.arrangements[arrIdx].garlandFeet = parseInt(e.target.value, 10) || 8;
          updateStemBudget();
        });
        return;
      }

      if (sizes.length > 0) {
        var sizeGrid = document.createElement('div');
        sizeGrid.className = 'pp-v2-size-grid';
        sizes.forEach(function (sz) {
          var card = document.createElement('div');
          card.className = 'pp-v2-size-card';
          if (itemSize === sz.id) card.classList.add('is-selected');
          card.innerHTML =
            '<div class="pp-v2-size-name">' + sz.label + '</div>' +
            '<div class="pp-v2-size-stems">' + sz.stems + ' stems</div>';
          card.addEventListener('click', function () {
            if (subIdx !== null && arr.perItem) {
              arr.perItem[subIdx].size = sz.id;
            } else {
              state.arrangements[arrIdx].size = sz.id;
              // Also update all perItem entries if they exist (sync when editing shared)
              if (arr.perItem) {
                arr.perItem.forEach(function (pi) { pi.size = sz.id; });
              }
            }
            sizeGrid.querySelectorAll('.pp-v2-size-card').forEach(function (c) { c.classList.remove('is-selected'); });
            card.classList.add('is-selected');
            updateStemBudget();
          });
          sizeGrid.appendChild(card);
        });
        parentEl.appendChild(sizeGrid);

        // Auto-select if none set
        if (!itemSize && sizes.length) {
          var defaultIdx = Math.min(1, sizes.length - 1);
          var defaultSize = sizes[defaultIdx].id;
          if (subIdx !== null && arr.perItem) {
            arr.perItem[subIdx].size = defaultSize;
          } else {
            arr.size = defaultSize;
          }
          sizeGrid.children[defaultIdx].classList.add('is-selected');
        }
      }

      // Density picker (not for wearables)
      var wearables = ['boutonniere','corsage','hair-comb'];
      if (wearables.indexOf(arr.type) === -1) {
        var densityRow = document.createElement('div');
        densityRow.className = 'pp-v2-density-row';
        ['airy','classic','lush'].forEach(function (d) {
          var dCard = document.createElement('div');
          dCard.className = 'pp-v2-density-card';
          if (itemDensity === d) dCard.classList.add('is-selected');
          dCard.textContent = d.charAt(0).toUpperCase() + d.slice(1);
          if (d === 'airy') dCard.textContent += ' (\u00D70.85)';
          else if (d === 'lush') dCard.textContent += ' (\u00D71.25)';
          dCard.addEventListener('click', function () {
            if (subIdx !== null && arr.perItem) {
              arr.perItem[subIdx].density = d;
            } else {
              state.arrangements[arrIdx].density = d;
              if (arr.perItem) {
                arr.perItem.forEach(function (pi) { pi.density = d; });
              }
            }
            densityRow.querySelectorAll('.pp-v2-density-card').forEach(function (c) { c.classList.remove('is-selected'); });
            dCard.classList.add('is-selected');
            updateStemBudget();
          });
          densityRow.appendChild(dCard);
        });
        parentEl.appendChild(densityRow);
      }
    }

    function renderSizeStep() {
      var container = q('#ppSizeContainer-' + sectionId);
      if (!container) return;
      container.innerHTML = '';

      state.arrangements.forEach(function (arr, arrIdx) {
        if (arr.qty <= 0) return;
        var meta = ARRANGEMENT_META[arr.type] || { label: arr.type };
        var section = document.createElement('div');
        section.className = 'pp-v2-size-section';

        var sizes = SIZE_OPTIONS[arr.type] || SIZE_OPTIONS['bouquet'] || [];

        if (arr.qty <= 1) {
          // Single — simple label + picker
          var label = document.createElement('div');
          label.className = 'pp-v2-size-label';
          label.textContent = meta.label;
          section.appendChild(label);
          renderSizeDensityBlock(arr, arrIdx, null, sizes, section);
        } else {
          // Multiple — shared picker + customize toggle
          var isCustomized = !!arr.perItem;

          var header = document.createElement('div');
          header.className = 'pp-v2-size-header';
          header.innerHTML =
            '<div class="pp-v2-size-label">' + meta.label + ' (\u00D7' + arr.qty + ')</div>' +
            '<button type="button" class="pp-v2-customize-toggle pp-link">' +
            (isCustomized ? 'Use same size' : 'Customize each') +
            '</button>';
          section.appendChild(header);

          var toggleBtn = header.querySelector('.pp-v2-customize-toggle');
          toggleBtn.addEventListener('click', function () {
            if (arr.perItem) {
              // Collapse back to shared
              delete arr.perItem;
            } else {
              // Expand to per-item
              arr.perItem = [];
              for (var i = 0; i < arr.qty; i++) {
                arr.perItem.push({ size: arr.size, density: arr.density });
              }
            }
            renderSizeStep();
          });

          if (isCustomized) {
            // Per-item pickers
            for (var i = 0; i < arr.qty; i++) {
              var subSection = document.createElement('div');
              subSection.className = 'pp-v2-size-sub';
              var subLabel = document.createElement('div');
              subLabel.className = 'pp-v2-size-sub-label';
              subLabel.textContent = meta.label + ' #' + (i + 1);
              subSection.appendChild(subLabel);
              renderSizeDensityBlock(arr, arrIdx, i, sizes, subSection);
              section.appendChild(subSection);
            }
          } else {
            // Shared picker for all
            renderSizeDensityBlock(arr, arrIdx, null, sizes, section);
          }
        }

        container.appendChild(section);
      });

      updateStemBudget();
    }

    function getStemBudget() {
      var total = 0;
      state.arrangements.forEach(function (arr) {
        if (arr.qty <= 0) return;
        if (arr.type === 'garland') {
          var feet = arr.garlandFeet || 8;
          var perFoot = GARLAND_PER_FOOT[arr.density || 'medium'] || 6;
          total += feet * perFoot * arr.qty;
          return;
        }
        var packType = PACK_SIZES[arr.type] || PACK_SIZES['bouquet'];
        if (arr.perItem && arr.perItem.length) {
          arr.perItem.forEach(function (pi) {
            var sizeData = packType[pi.size] || packType[Object.keys(packType)[0]];
            if (!sizeData) return;
            var avg = (sizeData.total[0] + sizeData.total[1]) / 2;
            var mult = DENSITY_MULT[pi.density] || 1;
            total += Math.round(avg * mult);
          });
        } else {
          var sizeData = packType[arr.size] || packType[Object.keys(packType)[0]];
          if (!sizeData) return;
          var avg = (sizeData.total[0] + sizeData.total[1]) / 2;
          var mult = DENSITY_MULT[arr.density] || 1;
          total += Math.round(avg * mult) * arr.qty;
        }
      });
      return total;
    }

    function getStemBudgetMax() {
      var total = 0;
      state.arrangements.forEach(function (arr) {
        if (arr.qty <= 0) return;
        if (arr.type === 'garland') {
          var feet = arr.garlandFeet || 8;
          var perFoot = GARLAND_PER_FOOT[arr.density || 'medium'] || 6;
          total += feet * perFoot * arr.qty;
          return;
        }
        var packType = PACK_SIZES[arr.type] || PACK_SIZES['bouquet'];
        if (arr.perItem && arr.perItem.length) {
          arr.perItem.forEach(function (pi) {
            var sizeData = packType[pi.size] || packType[Object.keys(packType)[0]];
            if (!sizeData) return;
            var upper = sizeData.total[1];
            var mult = DENSITY_MULT[pi.density] || 1;
            total += Math.round(upper * mult);
          });
        } else {
          var sizeData = packType[arr.size] || packType[Object.keys(packType)[0]];
          if (!sizeData) return;
          var upper = sizeData.total[1];
          var mult = DENSITY_MULT[arr.density] || 1;
          total += Math.round(upper * mult) * arr.qty;
        }
      });
      return total;
    }

    function tryAutoUpgradeSize() {
      var totalStems = totalSelections();
      var maxBudget = getStemBudgetMax();
      if (maxBudget <= 0 || totalStems <= maxBudget) return false;

      for (var i = 0; i < state.arrangements.length; i++) {
        var arr = state.arrangements[i];
        if (arr.qty <= 0 || arr.type === 'garland') continue;
        var sizes = SIZE_OPTIONS[arr.type] || SIZE_OPTIONS['bouquet'] || [];
        var curIdx = sizes.findIndex(function (sz) { return sz.id === arr.size; });
        if (curIdx >= 0 && curIdx < sizes.length - 1) {
          var next = sizes[curIdx + 1];
          arr.size = next.id;
          showUpgradeToast(ARRANGEMENT_META[arr.type] || { label: arr.type }, next);
          return true;
        }
      }
      return false;
    }

    function showUndoToast(itemTitle, onUndo) {
      var existing = root.querySelector('.pp-undo-toast');
      if (existing) existing.remove();
      var toast = document.createElement('div');
      toast.className = 'pp-undo-toast';
      toast.innerHTML =
        '<span>Removed ' + itemTitle + '</span>' +
        '<button type="button" class="pp-undo-btn">Undo</button>';
      toast.querySelector('.pp-undo-btn').addEventListener('click', function () {
        onUndo();
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.remove(); }, 300);
      });
      root.appendChild(toast);
      setTimeout(function () { toast.classList.add('is-visible'); }, 10);
      setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.remove(); }, 300);
      }, 4000);
    }

    function showUpgradeToast(meta, tier) {
      var existing = root.querySelector('.pp-upgrade-toast');
      if (existing) existing.remove();
      var toast = document.createElement('div');
      toast.className = 'pp-upgrade-toast';
      toast.textContent = 'Upgraded ' + meta.label + ' to ' + tier.label + ' (' + tier.stems + ' stems)';
      root.appendChild(toast);
      setTimeout(function () { toast.classList.add('is-visible'); }, 10);
      setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.remove(); }, 300);
      }, 3000);
    }

    function updateStemBudget() {
      var el = q('#ppStemBudget-' + sectionId);
      if (!el) return;
      var total = getStemBudget();
      if (total > 0) {
        el.hidden = false;
        el.textContent = 'Your stem budget: ~' + total + ' stems total across all arrangements';
      } else {
        el.hidden = true;
      }
    }

    // ================================================================
    // STEP 3: SERVICE LEVEL
    // ================================================================
    function renderServiceStep() {
      var container = q('#ppServiceContainer-' + sectionId);
      if (!container) return;
      container.innerHTML = '';

      state.arrangements.forEach(function (arr, arrIdx) {
        if (arr.qty <= 0) return;
        var meta = ARRANGEMENT_META[arr.type] || { label: arr.type };
        var pkgCat = ARRANGEMENT_TO_PACKAGE[arr.type] || 'circular';

        var section = document.createElement('div');
        section.className = 'pp-v2-service-section';

        var label = document.createElement('div');
        label.className = 'pp-v2-service-label';
        label.textContent = meta.label + (arr.qty > 1 ? ' (\u00D7' + arr.qty + ')' : '');
        section.appendChild(label);

        var grid = document.createElement('div');
        grid.className = 'pp-v2-service-grid';

        SERVICE_LEVELS.forEach(function (svc) {
          var priceKey = pkgCat + '|' + svc.id;
          var priceCents = PACKAGE_PRICE_MATRIX[priceKey];
          if (priceCents === undefined) priceCents = 0;

          var card = document.createElement('div');
          card.className = 'pp-v2-service-card';
          if (arr.serviceLevel === svc.id) card.classList.add('is-selected');
          if (svc.id === 'petite') card.classList.add('is-recommended');

          card.innerHTML =
            '<div class="pp-v2-service-name">' + svc.label + '</div>' +
            '<div class="pp-v2-service-price">' + (priceCents === 0 ? 'FREE' : money(priceCents)) + (arr.qty > 1 ? ' each' : '') + '</div>' +
            '<div class="pp-v2-service-desc">' + svc.desc + '</div>' +
            '<div class="pp-v2-service-perks">' + svc.perks + '</div>';

          card.addEventListener('click', function () {
            state.arrangements[arrIdx].serviceLevel = svc.id;
            grid.querySelectorAll('.pp-v2-service-card').forEach(function (c) { c.classList.remove('is-selected'); });
            card.classList.add('is-selected');
          });
          grid.appendChild(card);
        });

        section.appendChild(grid);
        container.appendChild(section);
      });
    }

    // ================================================================
    // STEP 4: COLOR / STYLE
    // ================================================================
    function renderColorStep() {
      var grid = q('#ppPaletteGrid-' + sectionId);
      if (!grid) return;
      grid.innerHTML = '';

      PALETTE_STYLES.forEach(function (p) {
        var card = document.createElement('div');
        card.className = 'pp-v2-palette-card';
        if (state.paletteStyle === p.id) card.classList.add('is-selected');

        var swatches = '<div class="pp-v2-palette-swatches">';
        p.swatches.forEach(function (c) {
          swatches += '<span class="pp-v2-swatch" style="background:' + c + '"></span>';
        });
        swatches += '</div>';

        card.innerHTML = swatches +
          '<div class="pp-v2-palette-name">' + p.label + '</div>' +
          '<div class="pp-v2-palette-desc">' + p.desc + '</div>';

        card.addEventListener('click', function () {
          state.paletteStyle = p.id;
          grid.querySelectorAll('.pp-v2-palette-card').forEach(function (c) { c.classList.remove('is-selected'); });
          card.classList.add('is-selected');
          // Show color family picker for monochromatic
          var familyGrid = q('#ppColorFamilyGrid-' + sectionId);
          if (familyGrid) familyGrid.hidden = p.id !== 'monochromatic';
          if (p.id !== 'monochromatic') state.colorFamily = null;
        });
        grid.appendChild(card);
      });

      renderColorFamilies();
    }

    function renderColorFamilies() {
      var grid = q('#ppColorFamilyGrid-' + sectionId);
      if (!grid) return;
      grid.innerHTML = '';
      grid.hidden = state.paletteStyle !== 'monochromatic';

      COLOR_FAMILIES.forEach(function (cf) {
        var card = document.createElement('div');
        card.className = 'pp-v2-color-family-card';
        if (state.colorFamily === cf.id) card.classList.add('is-selected');
        card.innerHTML =
          '<div class="pp-v2-color-dot" style="background:' + cf.color + '"></div>' +
          '<div class="pp-v2-color-label">' + cf.label + '</div>';
        card.addEventListener('click', function () {
          state.colorFamily = cf.id;
          grid.querySelectorAll('.pp-v2-color-family-card').forEach(function (c) { c.classList.remove('is-selected'); });
          card.classList.add('is-selected');
        });
        grid.appendChild(card);
      });
    }

    // ================================================================
    // STEPS 5-10: SOFT SORT & FLOWER SELECTION
    // ================================================================
    function softSortCollection(stepEl) {
      if (!stepEl) return;
      var grid = stepEl.querySelector('.pp-grid');
      if (!grid) return;

      var tiles = Array.from(grid.querySelectorAll('.pp-tile'));
      // Remove any existing dividers
      grid.querySelectorAll('.pp-v2-sort-divider').forEach(function (d) { d.remove(); });

      // Scoring: avatar tags + color token matching
      var avatar = state.avatar || settings.defaultAvatar;
      var prefs = getPreferredFamilies();

      var scored = tiles.map(function (tile) {
        var tags = (tile.dataset.tags || '').toLowerCase();
        var score = 0;

        // Avatar match
        if (tags.indexOf('popular-for:' + avatar) >= 0) score += 10;

        // Color match via product tags (legacy)
        for (var p = 0; p < prefs.length; p++) {
          if (tags.indexOf('color:' + prefs[p]) >= 0) {
            score += 5 - Math.min(p, 4);
            break;
          }
        }

        // Color match via variant color tokens (primary method)
        if (colorTokenMap && prefs.length > 0) {
          var handle = tile.dataset.handle;
          var product = getInlineProductJSON(handle);
          if (product && product.variants) {
            var bestMatch = prefs.length;
            product.variants.forEach(function (v) {
              if (!v || !v.available) return;
              var family = variantColorFamily(v);
              if (!family) return;
              var idx = prefs.indexOf(family);
              if (idx >= 0 && idx < bestMatch) bestMatch = idx;
            });
            if (bestMatch < prefs.length) {
              score += 8 - Math.min(bestMatch, 7);
            }
          }
        }

        return { tile: tile, score: score };
      });

      scored.sort(function (a, b) { return b.score - a.score; });

      // Find where "matching" ends and "more options" begins
      var matchCount = scored.filter(function (s) { return s.score > 0; }).length;

      scored.forEach(function (s, idx) {
        grid.appendChild(s.tile);
        s.tile.style.setProperty('--tile-index', idx);
        // Reset animation
        s.tile.style.animation = 'none';
        s.tile.offsetHeight; // trigger reflow
        s.tile.style.animation = '';
      });

      // Insert "More Options" divider with count
      if (matchCount > 0 && matchCount < tiles.length) {
        var moreCount = tiles.length - matchCount;
        var divider = document.createElement('div');
        divider.className = 'pp-v2-sort-divider';
        divider.textContent = moreCount + ' More Option' + (moreCount === 1 ? '' : 's');
        grid.insertBefore(divider, scored[matchCount].tile);
      }
    }

    // ================================================================
    // ROLLING TALLY
    // ================================================================
    function totalSelections() {
      return state.selections.reduce(function (sum, s) { return sum + s.qty; }, 0);
    }

    function totalCents() {
      return state.selections.reduce(function (sum, s) { return sum + s.priceCents * s.qty; }, 0);
    }

    function selectionsInRole(role) {
      return state.selections.filter(function (s) { return s.role === role; })
        .reduce(function (sum, s) { return sum + s.qty; }, 0);
    }

    function updateTally(stepEl) {
      if (!stepEl) return;
      var tallyEl = stepEl.querySelector('.pp-v2-tally');
      if (!tallyEl) return;

      var budget = getStemBudget();
      var totalStems = totalSelections();
      var rawPct = budget > 0 ? (totalStems / budget) * 100 : 0;
      var pct = Math.min(100, rawPct);

      var fill = tallyEl.querySelector('.pp-v2-tally-fill');
      var text = tallyEl.querySelector('.pp-v2-tally-text');

      if (fill) {
        fill.style.width = pct + '%';
        fill.classList.remove('is-green', 'is-amber');
        if (rawPct > 100) fill.classList.add('is-amber');
        else if (rawPct >= 80) fill.classList.add('is-green');
      }

      // Percentage label
      var pctEl = tallyEl.querySelector('.pp-v2-tally-pct');
      if (!pctEl && budget > 0) {
        pctEl = document.createElement('span');
        pctEl.className = 'pp-v2-tally-pct';
        tallyEl.appendChild(pctEl);
      }
      if (pctEl) pctEl.textContent = budget > 0 ? Math.round(rawPct) + '%' : '';

      if (text) {
        if (budget > 0) {
          var remaining = Math.max(0, budget - totalStems);
          text.textContent = totalStems + '/' + budget + ' stems' + (remaining > 0 ? ' \u2014 ' + remaining + ' more to reach your target' : ' \u2014 Target reached!');
        } else {
          text.textContent = totalStems + ' stems selected';
        }
      }
    }

    function updateCompositionBar() {
      // Composition bar removed from template — no-op
    }

    // ================================================================
    // ARRANGEMENT SUMMARY (shown at top of each collection step)
    // ================================================================
    function renderArrangementSummary() {
      // Update all arrangement summary panels in collection steps
      qa('.pp-v2-arr-summary').forEach(function (el) {
        if (!state.arrangements.length) {
          el.innerHTML = '';
          return;
        }
        var html = '<span class="pp-v2-arr-summary-title">You\u2019re building:</span> ';
        state.arrangements.forEach(function (arr) {
          if (arr.qty <= 0) return;
          var meta = ARRANGEMENT_META[arr.type] || { icon: '', label: arr.type };
          var svc = SERVICE_LEVELS.find(function (s) { return s.id === arr.serviceLevel; });
          var svcTag = svc ? (arr.serviceLevel === 'petite' ? 'DIY' : arr.serviceLevel === 'allin' ? 'PRO' : 'ASAP') : '';
          html += '<span class="pp-v2-arr-pill">' +
            meta.icon + ' ' + meta.label +
            (arr.qty > 1 ? ' \u00D7' + arr.qty : '') +
            (svcTag ? ' <span class="pp-v2-arr-svc">' + svcTag + '</span>' : '') +
            '</span>';
        });
        var budget = getStemBudget();
        if (budget > 0) {
          var totalStems = totalSelections();
          html += '<span class="pp-v2-arr-pill">\uD83C\uDF3F ' + totalStems + '/' + budget + ' stems</span>';
        }
        el.innerHTML = html;
      });
    }

    // ================================================================
    // SELECTION STATE & UI REFRESH
    // ================================================================
    function refreshUIFromSelections() {
      // Build qty-per-variant and qty-per-handle maps
      var qtyByVariant = {};
      var qtyByHandle = {};
      state.selections.forEach(function (s) {
        qtyByVariant[String(s.variantId)] = (qtyByVariant[String(s.variantId)] || 0) + s.qty;
        qtyByHandle[s.handle] = (qtyByHandle[s.handle] || 0) + s.qty;
      });

      qa('.pp-tile').forEach(function (t) {
        var handle = t.dataset.handle;
        var firstVid = t.dataset.firstVariantId;
        var count = qtyByHandle[handle] || 0;
        var vidCount = qtyByVariant[String(firstVid)] || 0;

        // Chip badge
        var chipEl = t.querySelector('.pp-chip');
        if (chipEl) {
          chipEl.textContent = '\u00D7' + count;
          chipEl.hidden = count === 0;
        }

        // Inline qty controls
        var qtyEl = t.querySelector('.pp-tile-qty');
        var qtyCountEl = t.querySelector('.pp-tile-qty-count');
        if (qtyEl && qtyCountEl) {
          if (count > 0) {
            qtyEl.hidden = false;
            qtyCountEl.textContent = String(count);
            t.classList.add('has-qty', 'is-selected');
          } else {
            qtyEl.hidden = true;
            t.classList.remove('has-qty', 'is-selected');
          }
        }
      });

      // Footer counters
      var selEl = q('#ppSelCount-' + sectionId);
      var shipBar = q('#ppShipBar-' + sectionId);
      if (selEl) selEl.textContent = totalSelections();
      if (shipBar) shipBar.textContent = milestoneCopy(totalCents());

      // Auto-upgrade size if stems exceed current tier max
      if (tryAutoUpgradeSize()) {
        // Budget changed — refresh counters
        if (selEl) selEl.textContent = totalSelections();
        if (shipBar) shipBar.textContent = milestoneCopy(totalCents());
      }

      // Update tally on current step
      var currentDef = stepDefs[state.currentStep];
      if (currentDef && currentDef.id.indexOf('collection-') === 0) {
        var activeStep = q('[data-step="' + currentDef.id + '"]');
        updateTally(activeStep);
      }
      updateCompositionBar();
      renderArrangementSummary();
    }

    // ================================================================
    // HPS BADGES
    // ================================================================
    function applyHPSBadges() {
      qa('.pp-tile').forEach(function (tile) {
        var hps = tile.dataset.hps;
        if (!hps) {
          // Check by handle for known multi-bloom stems
          var handle = (tile.dataset.handle || '').toLowerCase();
          Object.keys(HPS_DEFAULTS).forEach(function (key) {
            if (handle.indexOf(key) >= 0) hps = String(HPS_DEFAULTS[key]);
          });
        }
        if (hps && parseFloat(hps) > 1) {
          var badges = tile.querySelector('.pp-badges');
          if (badges && !badges.querySelector('.pp-badge--hps')) {
            var span = document.createElement('span');
            span.className = 'pp-badge pp-badge--hps';
            span.textContent = Math.round(parseFloat(hps)) + ' blooms/stem';
            badges.appendChild(span);
          }
        }
      });
    }
    applyHPSBadges();

    // ================================================================
    // JSON BADGES (from petal_badges.json)
    // ================================================================
    if (config.badgesURL) {
      fetch(config.badgesURL, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (map) {
          qa('.pp-tile').forEach(function (tile) {
            var key = tile.dataset.handle;
            var entry = map && (map[key] || map[(key || '').toLowerCase()]);
            if (!entry) return;
            var box = tile.querySelector('.pp-badges');
            (entry.badges || []).slice(0, 3).forEach(function (txt) {
              var span = document.createElement('span');
              span.className = 'pp-badge';
              span.textContent = txt;
              box.appendChild(span);
            });
          });
        })
        .catch(function () {});
    }

    // ================================================================
    // COLOR TOKEN MAP & AUTO-SWAP VARIANTS
    // ================================================================
    var colorTokenMap = null;

    if (config.colorTokensURL) {
      fetch(config.colorTokensURL, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (map) {
          delete map._comment;
          colorTokenMap = map;
        })
        .catch(function () {});
    }

    function getPreferredFamilies() {
      if (state.paletteStyle === 'monochromatic' && state.colorFamily) {
        return [state.colorFamily];
      }
      return PALETTE_COLOR_PREFS[state.paletteStyle] || [];
    }

    function variantColorFamily(variant) {
      if (!colorTokenMap || !variant) return null;
      var opts = variant.options || [variant.option1, variant.option2, variant.option3];
      for (var i = 0; i < opts.length; i++) {
        if (!opts[i]) continue;
        var family = colorTokenMap[String(opts[i]).toLowerCase()];
        if (family) return family;
      }
      return null;
    }

    function autoSwapVariants(stepEl) {
      if (!stepEl || !colorTokenMap) return;
      var prefs = getPreferredFamilies();
      if (!prefs.length) return;

      var tiles = stepEl.querySelectorAll('.pp-tile');
      tiles.forEach(function (tile) {
        var handle = tile.dataset.handle;
        var variantCount = parseInt(tile.dataset.variantsCount || '1', 10);
        if (variantCount <= 1) return;

        var product = getInlineProductJSON(handle);
        if (!product || !product.variants || product.variants.length <= 1) return;

        // Find the best variant matching the palette preferences
        var bestVariant = null;
        var bestPriority = prefs.length;
        product.variants.forEach(function (v) {
          if (!v.available) return;
          var family = variantColorFamily(v);
          if (!family) return;
          var idx = prefs.indexOf(family);
          if (idx >= 0 && idx < bestPriority) {
            bestPriority = idx;
            bestVariant = v;
          }
        });

        if (!bestVariant) return;
        var currentVid = tile.dataset.firstVariantId;
        if (String(bestVariant.id) === String(currentVid)) return;

        // Swap tile data to the matching variant
        tile.dataset.firstVariantId = String(bestVariant.id);
        tile.dataset.firstVariantPrice = String(bestVariant.price);
        tile.dataset.firstVariantAvailable = String(bestVariant.available);

        // Swap image
        var img = tile.querySelector('img');
        if (img && bestVariant.featured_image && bestVariant.featured_image.src) {
          img.src = bestVariant.featured_image.src;
        }

        // Swap price display
        var priceEl = tile.querySelector('.pp-tprice');
        if (priceEl) priceEl.textContent = money(bestVariant.price);

        // Swap variant title under product name
        var nameEl = tile.querySelector('.pp-tname');
        if (nameEl) {
          var variantLabel = (bestVariant.options || []).join(' / ');
          if (variantLabel && variantLabel !== 'Default Title') {
            nameEl.textContent = (tile.dataset.title || '') + ' — ' + variantLabel;
          }
        }
      });
    }

    // ================================================================
    // QUICK-VIEW MODAL (adapted from V1)
    // ================================================================
    var qv = q('#ppQV-' + sectionId);
    var qvX = q('#ppQVX-' + sectionId);
    var qvImg = q('#ppQVImg-' + sectionId);
    var qvName = q('#ppQVName-' + sectionId);
    var qvPrice = q('#ppQVPrice-' + sectionId);
    var qvOptions = q('#ppQVOptions-' + sectionId);
    var qvForm = q('#ppQVForm-' + sectionId);
    var qvQty = q('#ppQVQty-' + sectionId);
    var qvStock = q('#ppQVStock-' + sectionId);
    var LOW_STOCK_THRESHOLD = parseInt(settings.lowStockThreshold || 3, 10);
    var __ppIsStockChecking = false;

    var FEATURES_HTML = '', CARE_HTML = '';
    try {
      var staticEl = document.getElementById('ppStatic-' + sectionId);
      var staticData = staticEl ? JSON.parse(staticEl.textContent) : {};
      FEATURES_HTML = staticData.features || '';
      CARE_HTML = staticData.care || '';
    } catch (_) {}

    function setAccordionHtml(key, html) {
      var wrapper = qv.querySelector('.pp-collapse[data-field="' + key + '"]');
      if (!wrapper) return;
      var has = !!(html && html.trim());
      wrapper.hidden = !has;
      wrapper.querySelector('.pp-collapse-body').innerHTML = has ? html : '';
      if (key === 'body') {
        if (has) wrapper.setAttribute('open', '');
        else wrapper.removeAttribute('open');
      }
    }

    var qvData = null, qvVariant = null;
    var qvContext = { handle: '', title: '', image: '', collection: '', role: '' };
    var qvLocalStock = null;

    function getLocalVariantStockMap(handle) {
      var el = root.querySelector('.pp-stock[data-handle="' + handle + '"]');
      if (!el) return null;
      try { return JSON.parse(el.textContent || '{}'); } catch (_) { return null; }
    }

    function getInlineProductJSON(handle) {
      var el = root.querySelector('.pp-prod[data-handle="' + handle + '"]');
      if (!el) return null;
      try { return JSON.parse(el.textContent || '{}'); } catch (_) { return null; }
    }

    function getOptionsWithValues(product) {
      if (Array.isArray(product && product.options_with_values) && product.options_with_values.length) {
        return product.options_with_values.map(function (o) {
          return { name: o.name || 'Option', values: Array.from(new Set((o.values || []).map(String))) };
        });
      }
      var names = Array.isArray(product && product.options) ? product.options : [];
      var byIdx = names.map(function () { return new Set(); });
      (product.variants || []).forEach(function (v) {
        if (v.option1 != null) byIdx[0] && byIdx[0].add(String(v.option1));
        if (v.option2 != null) byIdx[1] && byIdx[1].add(String(v.option2));
        if (v.option3 != null) byIdx[2] && byIdx[2].add(String(v.option3));
      });
      return names.map(function (name, idx) {
        return { name: String(name || 'Option ' + (idx + 1)), values: Array.from(byIdx[idx] || []) };
      });
    }

    function openQV(handle, title, image, collection, role, extra) {
      extra = extra || {};
      qv.setAttribute('open', '');
      qv.setAttribute('aria-hidden', 'false');
      qvName.textContent = title || '';
      qvImg.src = image || '';
      qvOptions.innerHTML = '';
      qvQty.value = 1;
      var btnTitle = qv.querySelector('.pp-btn-title');
      if (btnTitle) btnTitle.textContent = 'Add to cart';
      if (qvStock) {
        qvStock.hidden = true;
        qvStock.textContent = '';
        qvStock.classList.remove('ok', 'low', 'out');
      }
      qvData = null;
      qvVariant = null;
      qvContext = { handle: handle, title: title, image: image, collection: collection, role: role || '', preferredVariantId: extra.preferredVariantId || null };
      qvLocalStock = getLocalVariantStockMap(handle);
      setAccordionHtml('body', htmlDecode(extra.body || ''));
      setAccordionHtml('features', FEATURES_HTML);
      setAccordionHtml('care', CARE_HTML);
      updateSlotChip();

      var inline = getInlineProductJSON(handle);
      var loadProduct = inline
        ? Promise.resolve(inline)
        : fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('fetch'); return r.json(); });

      loadProduct.then(function (prod) {
        qvData = prod;
        qvOptions.innerHTML = '';
        var optionDefs = getOptionsWithValues(prod);
        optionDefs.forEach(function (opt, idx) {
          var wrap = document.createElement('label');
          wrap.className = 'pp-qv-field';
          wrap.innerHTML = '<div class="pp-qv-label">' + opt.name + '</div>';
          var sel = document.createElement('select');
          sel.dataset.index = idx;
          (opt.values || []).forEach(function (v) {
            var o = document.createElement('option');
            o.value = v;
            o.textContent = v;
            sel.appendChild(o);
          });
          wrap.appendChild(sel);
          qvOptions.appendChild(wrap);
        });
        bindQtyHandlers();
        // Prefer the color-swapped variant if one was set
        var preferredVid = qvContext.preferredVariantId;
        var firstAvail = null;
        if (preferredVid) {
          firstAvail = (prod.variants || []).find(function (v) { return v && String(v.id) === String(preferredVid) && v.available; });
        }
        if (!firstAvail) {
          firstAvail = (prod.variants || []).find(function (v) { return v && v.available; }) || (prod.variants || [])[0];
        }
        if (firstAvail && Array.isArray(firstAvail.options)) {
          Array.from(qvOptions.querySelectorAll('select')).forEach(function (sel, idx) {
            if (firstAvail.options[idx] != null) sel.value = firstAvail.options[idx];
          });
        }
        chooseVariantFromSelects();
        bindQtyHandlers();
        Array.from(qvOptions.querySelectorAll('select')).forEach(function (s) {
          s.addEventListener('change', chooseVariantFromSelects);
        });
      }).catch(function () {
        if (qvPrice) qvPrice.textContent = 'Unavailable';
      });
    }

    function closeQV() {
      qv.removeAttribute('open');
      qv.setAttribute('aria-hidden', 'true');
    }

    if (qvX) qvX.addEventListener('click', closeQV);
    qv.addEventListener('click', function (e) { if (e.target === qv) closeQV(); });

    function enforceQtyBounds() {
      var min = parseInt(qvQty.min || 1, 10);
      var max = parseInt(qvQty.max || 9999, 10);
      var v = parseInt(qvQty.value || min, 10);
      if (isNaN(v)) v = min;
      if (v < min) v = min;
      if (v > max) v = max;
      qvQty.value = v;
    }

    function bindQtyHandlers() {
      if (!qvForm || !qvQty) return;
      if (!qvQty.min) qvQty.min = '1';
      if (!qvQty.step) qvQty.step = '1';
      if (!qvForm.__ppQtyBound) {
        qvForm.__ppQtyBound = true;
        qvForm.addEventListener('click', function (ev) {
          var btn = ev.target.closest('.pp-qtystep [data-step]');
          if (!btn) return;
          if (__ppIsStockChecking) return;
          ev.preventDefault();
          var delta = parseInt(btn.dataset.step, 10) || 0;
          var min = parseInt(qvQty.min || '1', 10);
          var max = parseInt(qvQty.max || '9999', 10);
          var val = parseInt(qvQty.value || '1', 10) + delta;
          if (val < min) val = min;
          if (val > max) val = max;
          qvQty.value = String(val);
          enforceQtyBounds();
        }, { passive: false });
      }
      if (!qvQty.__ppClampBound) {
        qvQty.__ppClampBound = true;
        ['input', 'change', 'blur'].forEach(function (evt) {
          qvQty.addEventListener(evt, enforceQtyBounds, { passive: true });
        });
      }
    }

    function chooseVariantFromSelects() {
      if (!qvData) return;
      var sels = Array.from(qvOptions.querySelectorAll('select'));
      var picks = sels.map(function (s) { return s.value; });
      var found = (qvData.variants || []).find(function (v) {
        return v && v.options && v.options.every(function (val, i) { return String(val) === String(picks[i]); });
      }) || (qvData.variants || [])[0];
      qvVariant = found;
      var cents = parseInt(found && found.price || 0, 10);
      if (qvPrice) qvPrice.textContent = money(cents);
      if (found && found.featured_image && found.featured_image.src) qvImg.src = found.featured_image.src;
      updateStock(found);
      enforceQtyBounds();
    }

    function __ppSetQtyDisabled(disabled) {
      if (qvQty) qvQty.disabled = disabled;
      var stepBtns = qvForm ? qvForm.querySelectorAll('.pp-qtystep button') : [];
      stepBtns.forEach(function (b) { b.disabled = disabled; });
    }

    async function ensureVariantQty(found) {
      var key = String(found && found.id || '');
      if (qvLocalStock && Object.prototype.hasOwnProperty.call(qvLocalStock, key)) {
        var raw = qvLocalStock[key];
        var n = Number(raw);
        if (Number.isFinite(n)) {
          var policy = String(found.inventory_policy || '').toLowerCase();
          if (n <= 0 && policy === 'continue' && !!found.available) return null;
          return n;
        }
      }
      var directNum = Number(found && found.inventory_quantity);
      if (Number.isFinite(directNum)) {
        var policy2 = String(found.inventory_policy || '').toLowerCase();
        if (directNum <= 0 && policy2 === 'continue' && !!found.available) return null;
        return directNum;
      }
      try {
        var r = await fetch('/variants/' + found.id + '.json', { credentials: 'same-origin' });
        if (!r.ok) return null;
        var j = await r.json();
        var v = Number(j && j.variant && j.variant.inventory_quantity);
        if (!Number.isFinite(v)) return null;
        var policy3 = String((j.variant && j.variant.inventory_policy) || (found && found.inventory_policy) || '').toLowerCase();
        if (v <= 0 && policy3 === 'continue' && !!found.available) return null;
        return v;
      } catch (_) { return null; }
    }

    async function updateStock(found) {
      if (!qvStock) return;
      var addBtn = qvForm.querySelector('button[type="submit"]');
      qvStock.hidden = false;
      qvStock.className = 'pp-qv-stock';
      qvStock.innerHTML = '<span class="pp-dot"></span>Checking stock\u2026';
      __ppIsStockChecking = true;
      var qty = await ensureVariantQty(found);
      __ppIsStockChecking = false;
      if (qty === null) {
        var available = !!(found && found.available);
        qvStock.innerHTML = '<span class="pp-dot"></span>' + (available ? 'In stock' : 'Sold out');
        qvStock.classList.add(available ? 'ok' : 'out');
        if (addBtn) addBtn.disabled = !available;
        if (available) { qvQty.removeAttribute('max'); __ppSetQtyDisabled(false); }
        else { qvQty.value = 1; qvQty.max = 1; __ppSetQtyDisabled(true); }
        enforceQtyBounds();
        return;
      }
      if (qty <= 0) {
        qvStock.innerHTML = '<span class="pp-dot"></span>Sold out';
        qvStock.classList.add('out');
        if (addBtn) addBtn.disabled = true;
        qvQty.value = 1; qvQty.max = 1;
        __ppSetQtyDisabled(true);
        enforceQtyBounds();
      } else {
        var low = qty <= LOW_STOCK_THRESHOLD;
        qvStock.innerHTML = '<span class="pp-dot"></span>' + (low ? 'Low stock: ' + qty + ' left' : 'In stock: ' + qty);
        qvStock.classList.add(low ? 'low' : 'ok');
        if (addBtn) addBtn.disabled = !(found && found.available);
        qvQty.max = qty;
        enforceQtyBounds();
      }
    }

    // QV form submit — add to selections
    if (qvForm) qvForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!qvVariant) return;
      var qty = Math.max(1, parseInt(qvQty.value || 1, 10));
      var key = String(qvVariant.id);
      var existing = state.selections.find(function (s) { return String(s.variantId) === key; });
      if (existing) {
        existing.qty += qty;
      } else {
        state.selections.push({
          handle: qvContext.handle,
          collection: qvContext.collection,
          role: qvContext.role,
          variantId: qvVariant.id,
          variantTitle: qvVariant.title,
          priceCents: parseInt(qvVariant.price || 0, 10),
          qty: qty,
          title: qvContext.title,
          image: qvImg.src
        });
      }
      closeQV();
      refreshUIFromSelections();
    });

    // ================================================================
    // QUICK-ADD: + button and inline qty controls
    // ================================================================
    function quickAdd(tile) {
      var handle = tile.dataset.handle;
      var variantCount = parseInt(tile.dataset.variantsCount || '1', 10);
      var firstVariantId = tile.dataset.firstVariantId;
      var firstVariantPrice = parseInt(tile.dataset.firstVariantPrice || '0', 10);
      var firstVariantAvailable = tile.dataset.firstVariantAvailable === 'true';

      // Multi-variant → open QV modal
      if (variantCount > 1) {
        openQV(
          handle,
          tile.dataset.title,
          (tile.querySelector('img') || {}).getAttribute('src') || '',
          tile.dataset.collection || '',
          tile.dataset.role || '',
          { body: tile.dataset.body || '', preferredVariantId: firstVariantId }
        );
        return;
      }

      // Single-variant → add directly
      if (!firstVariantAvailable) return;
      var existing = state.selections.find(function (s) { return String(s.variantId) === String(firstVariantId); });
      if (existing) {
        existing.qty += 1;
      } else {
        state.selections.push({
          handle: handle,
          collection: tile.dataset.collection || '',
          role: tile.dataset.role || '',
          variantId: parseInt(firstVariantId, 10),
          variantTitle: 'Default',
          priceCents: firstVariantPrice,
          qty: 1,
          title: tile.dataset.title || '',
          image: (tile.querySelector('img') || {}).getAttribute('src') || ''
        });
      }
      refreshUIFromSelections();
      // Animate the + button
      var addBtn = tile.querySelector('.pp-tile-add');
      if (addBtn) {
        addBtn.style.transform = 'scale(1.3)';
        setTimeout(function () { addBtn.style.transform = ''; }, 150);
      }
    }

    function adjustTileQty(tile, delta) {
      var handle = tile.dataset.handle;
      var firstVariantId = tile.dataset.firstVariantId;
      // Find the selection for this tile
      var sel = state.selections.find(function (s) { return String(s.variantId) === String(firstVariantId); });
      if (!sel && delta > 0) {
        quickAdd(tile);
        return;
      }
      if (!sel) return;
      sel.qty += delta;
      if (sel.qty <= 0) {
        state.selections = state.selections.filter(function (s) { return s !== sel; });
      }
      refreshUIFromSelections();
    }

    // Event delegation for quick-add and qty controls
    root.addEventListener('click', function (e) {
      // Quick-add "+" button
      var addBtn = e.target.closest('.pp-tile-add');
      if (addBtn) {
        e.stopPropagation();
        var tile = addBtn.closest('.pp-tile');
        if (tile) quickAdd(tile);
        return;
      }

      // Inline qty +/- buttons
      var qtyBtn = e.target.closest('.pp-tile-qty-btn');
      if (qtyBtn) {
        e.stopPropagation();
        var tile2 = qtyBtn.closest('.pp-tile');
        var delta = parseInt(qtyBtn.dataset.delta || '0', 10);
        if (tile2 && delta) adjustTileQty(tile2, delta);
        return;
      }

      // Tile click → open QV (for viewing details or multi-variant)
      var onControl = e.target.closest('.pp-qtystep, .pp-skip, .pp-btn, .pp-cta, .pp-v2-avatar-card, .pp-v2-arrangement-card, .pp-v2-size-card, .pp-v2-density-card, .pp-v2-service-card, .pp-v2-palette-card, .pp-v2-color-family-card, [data-remove], .pp-link, .pp-qv, .pp-tile-actions, .pp-tile-qty, details, summary');
      if (onControl) return;
      var tile3 = e.target.closest('.pp-tile');
      if (!tile3) return;
      openQV(
        tile3.dataset.handle,
        tile3.dataset.title,
        (tile3.querySelector('img') || {}).getAttribute('src') || '',
        tile3.dataset.collection || '',
        tile3.dataset.role || '',
        { body: tile3.dataset.body || '', preferredVariantId: tile3.dataset.firstVariantId }
      );
    });

    // ================================================================
    // STEP 11: REVIEW & CHECKOUT
    // ================================================================
    function renderReview() {
      var body = q('#ppReviewBody-' + sectionId);
      if (!body) return;
      body.innerHTML = '';

      var flowerSubtotal = 0;
      var feeSubtotal = 0;

      // Group selections by collection for display
      var byCollection = {};
      state.selections.forEach(function (s) {
        if (!byCollection[s.collection]) byCollection[s.collection] = [];
        byCollection[s.collection].push(s);
      });

      // Flower selections section
      var collections = config.collections || [];
      collections.forEach(function (col) {
        var items = byCollection[col.handle];
        if (!items || !items.length) return;

        var section = document.createElement('div');
        section.className = 'pp-v2-review-section';

        var title = document.createElement('div');
        title.className = 'pp-v2-review-section-title';
        title.textContent = col.title;
        section.appendChild(title);

        items.forEach(function (s) {
          flowerSubtotal += s.priceCents * s.qty;
          var row = document.createElement('div');
          row.className = 'pp-v2-review-item';
          row.innerHTML =
            '<div class="pp-v2-review-item-meta">' +
            '<img class="pp-v2-review-thumb" src="' + (s.image || '') + '" alt="">' +
            '<div class="pp-v2-review-item-info">' +
            '<div>' + s.title + '</div>' +
            '<div class="pp-v2-review-item-detail">' + s.variantTitle + ' \u00B7 ' + money(s.priceCents) + ' \u00D7 ' + s.qty + '</div>' +
            '</div></div>' +
            '<button class="pp-link" data-remove-variant="' + s.variantId + '">Remove</button>';
          row.querySelector('[data-remove-variant]').addEventListener('click', function () {
            // Undo-able remove: hide row, show undo toast, finalize after 4s
            row.style.opacity = '0.3';
            row.style.pointerEvents = 'none';
            var removed = s;
            var undone = false;

            showUndoToast(removed.title, function () {
              undone = true;
              row.style.opacity = '';
              row.style.pointerEvents = '';
            });

            setTimeout(function () {
              if (undone) return;
              state.selections = state.selections.filter(function (x) { return x !== removed; });
              refreshUIFromSelections();
              renderReview();
            }, 4000);
          });
          section.appendChild(row);
        });

        body.appendChild(section);
      });

      // Assembly fees section
      if (state.arrangements.length) {
        var feeSection = document.createElement('div');
        feeSection.className = 'pp-v2-review-section';
        var feeTitle = document.createElement('div');
        feeTitle.className = 'pp-v2-review-section-title';
        feeTitle.textContent = 'Assembly & Service Fees';
        feeSection.appendChild(feeTitle);

        state.arrangements.forEach(function (arr) {
          if (arr.qty <= 0) return;
          var meta = ARRANGEMENT_META[arr.type] || { label: arr.type };
          var pkgCat = ARRANGEMENT_TO_PACKAGE[arr.type] || 'circular';
          var priceKey = pkgCat + '|' + arr.serviceLevel;
          var unitFee = PACKAGE_PRICE_MATRIX[priceKey] || 0;
          var totalFee = unitFee * arr.qty;
          feeSubtotal += totalFee;

          var svcLabel = SERVICE_LEVELS.find(function (s) { return s.id === arr.serviceLevel; });
          var row = document.createElement('div');
          row.className = 'pp-v2-review-fee';
          row.innerHTML =
            '<span>' + meta.label + (arr.qty > 1 ? ' \u00D7' + arr.qty : '') + ' \u2014 ' + (svcLabel ? svcLabel.label : arr.serviceLevel) + '</span>' +
            '<span>' + (totalFee === 0 ? 'FREE' : money(totalFee)) + '</span>';
          feeSection.appendChild(row);
        });

        body.appendChild(feeSection);
      }

      // Totals
      var totalsEl = q('#ppReviewTotals-' + sectionId);
      if (totalsEl) {
        var grandTotal = flowerSubtotal + feeSubtotal;
        totalsEl.innerHTML =
          '<div class="pp-v2-review-total-row"><span>Flowers</span><span>' + money(flowerSubtotal) + '</span></div>' +
          '<div class="pp-v2-review-total-row"><span>Assembly fees</span><span>' + (feeSubtotal === 0 ? 'FREE' : money(feeSubtotal)) + '</span></div>' +
          '<div class="pp-v2-review-total-row is-grand"><span>Subtotal</span><span>' + money(grandTotal) + '</span></div>';
      }

      // Grand Slam tiers
      var tiersEl = q('#ppTiers-' + sectionId);
      if (tiersEl) {
        tiersEl.innerHTML = '';
        var subtotal = flowerSubtotal + feeSubtotal;
        TIERS.forEach(function (t) {
          var unlocked = subtotal >= t.cents;
          var tier = document.createElement('div');
          tier.className = 'pp-v2-tier ' + (unlocked ? 'is-unlocked' : 'is-locked');
          tier.innerHTML =
            '<span class="pp-v2-tier-dot"></span>' +
            '<span>' + (unlocked ? '\u2713 ' + t.label : t.label + ' \u2014 ' + money(Math.max(0, t.cents - subtotal)) + ' away') + '</span>';
          tiersEl.appendChild(tier);
        });
      }
    }

    // Notes character counter
    var notesTA = q('#ppNotes-' + sectionId);
    var notesCtr = q('#ppNotesCounter-' + sectionId);
    if (notesTA && notesCtr) {
      notesTA.addEventListener('input', function () {
        var len = notesTA.value.length;
        var max = 500;
        notesCtr.textContent = len + '/' + max;
        notesCtr.classList.toggle('is-near', len >= max * 0.9 && len < max);
        notesCtr.classList.toggle('is-at', len >= max);
      });
    }

    // ================================================================
    // ADD ALL TO CART
    // ================================================================
    var addAllBtn = q('#ppAddAll-' + sectionId);
    var editDate = q('#ppEditDate-' + sectionId);
    if (editDate) editDate.addEventListener('click', function () {
      var scrollTarget = stepper || root;
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (addAllBtn) addAllBtn.addEventListener('click', async function () {
      if (!state.selections.length) {
        alert('Select at least one item.');
        return;
      }

      // Buunto commit
      await new Promise(function (r) { setTimeout(r, 60); });
      var commit = window.__ppCommitBuunto || (async function () { return true; });
      var ok = await commit();
      if (!ok) {
        alert('Pick a delivery date & time before adding to cart (or the slot just sold out).');
        return;
      }

      var props = {
        'Shipping Date': (q('#ppShipDate-' + sectionId) || {}).value || '',
        'Shipping Day': (q('#ppShipDay-' + sectionId) || {}).value || '',
        'Shipping Time': (q('#ppShipTime-' + sectionId) || {}).value || '',
        '__buunto_selection': (q('#ppBuuntoSig-' + sectionId) || {}).value || '',
        '__buunto_slots_left': (q('#ppBuuntoLeft-' + sectionId) || {}).value || '',
        '__buunto_day_left': (q('#ppBuuntoDayLeft-' + sectionId) || {}).value || '',
        'Notes to Florist': (q('#ppNotes-' + sectionId) || {}).value || '',
        'Avatar': state.avatar || '',
        'Palette': state.paletteStyle || ''
      };

      if (!props['__buunto_selection'] && props['Shipping Date']) {
        props['__buunto_selection'] = buildBuuntoSignature(props['Shipping Date'], props['Shipping Time']);
      }

      if (!props['Shipping Date']) {
        alert('Please choose a shipping date.');
        return;
      }

      // Build items: flower selections + package variants
      var items = state.selections.map(function (s) {
        return { id: s.variantId, quantity: s.qty, properties: props };
      });

      // Add package/service variants
      state.arrangements.forEach(function (arr) {
        if (arr.qty <= 0) return;
        var pkgCat = ARRANGEMENT_TO_PACKAGE[arr.type] || 'circular';
        var priceKey = pkgCat + '|' + arr.serviceLevel;
        var variant = state.packageVariants[priceKey];
        if (variant && variant.id) {
          items.push({
            id: variant.id,
            quantity: arr.qty,
            properties: Object.assign({}, props, {
              'Arrangement': (ARRANGEMENT_META[arr.type] || {}).label || arr.type,
              'Size': arr.size || '',
              'Density': arr.density || ''
            })
          });
        }
      });

      try {
        addAllBtn.disabled = true;
        addAllBtn.textContent = 'Adding to cart\u2026';
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) throw new Error('Add failed');
        window.location.assign('/cart');
      } catch (e) {
        alert('Something went wrong adding to cart. Please try again.');
        addAllBtn.disabled = false;
        addAllBtn.textContent = 'Add all to cart';
      }
    });

    // ================================================================
    // PACKAGE PRODUCT LOADING
    // ================================================================
    function loadPackageProduct() {
      var handle = settings.packageProductHandle;
      if (!handle) return;
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          if (!prod) return;
          state.packageProduct = prod;
          // Build variant lookup from product data
          (prod.variants || []).forEach(function (v) {
            if (!v || !v.available) return;
            var title = (v.title || '').toLowerCase();
            // Map variant title patterns to our keys
            // Expected format: "Circular / Petite" or "Standing / All-In" etc.
            var parts = title.split('/').map(function (s) { return s.trim().toLowerCase(); });
            if (parts.length >= 2) {
              var cat = parts[0].replace(/\s+/g, '');
              var level = parts[1];
              // Normalize
              if (cat === 'circulararrangement' || cat === 'circular') cat = 'circular';
              else if (cat === 'standingdisplay' || cat === 'standing') cat = 'standing';
              else if (cat === 'casketspray' || cat === 'casket') cat = 'casket';
              else if (cat === 'heart/crosstribute' || cat === 'tribute') cat = 'tribute';
              else if (cat === 'garland/arch' || cat === 'garland') cat = 'garland';

              if (level.indexOf('asap') >= 0 || level.indexOf('rush') >= 0) level = 'asap';
              else if (level.indexOf('all-in') >= 0 || level.indexOf('allin') >= 0 || level.indexOf('pro') >= 0) level = 'allin';
              else level = 'petite';

              var key = cat + '|' + level;
              state.packageVariants[key] = { id: v.id, price: v.price };
            }
          });
        })
        .catch(function () {});
    }
    loadPackageProduct();

    // ================================================================
    // BUUNTO BRIDGE (verbatim from V1, adapted)
    // ================================================================
    (function buuntoBridgeExact() {
      var rootEl = root;
      var wrap = document.querySelector('#buunto-inline') || rootEl.querySelector('.pp-app') || null;

      function getBuuntoEls() {
        var scopes = [document.querySelector('#buunto-inline'), rootEl.querySelector('.pp-app'), document].filter(Boolean);
        for (var i = 0; i < scopes.length; i++) {
          var scope = scopes[i];
          var datePropInput = scope.querySelector('input[name="properties[Shipping Date]"]');
          var timeSelect = scope.querySelector('select[name="properties[Shipping Time]"]');
          var selectionSig = scope.querySelector('input[name="properties[__buunto_selection]"]');
          if (datePropInput || timeSelect || selectionSig) {
            return {
              datePropInput: datePropInput,
              dayPropInput: scope.querySelector('input[name="properties[Shipping Day]"]'),
              timeSelect: timeSelect,
              selectionSig: selectionSig,
              slotsLeftInput: scope.querySelector('input[name="properties[__buunto_slots_left]"]')
            };
          }
        }
        return {};
      }

      var hiddenDate = rootEl.querySelector('#ppShipDate-' + sectionId);
      var hiddenDay = rootEl.querySelector('#ppShipDay-' + sectionId);
      var hiddenTime = rootEl.querySelector('#ppShipTime-' + sectionId);
      var hiddenSig = rootEl.querySelector('#ppBuuntoSig-' + sectionId);

      function toYMD(d) {
        if (!(d instanceof Date) || isNaN(d)) return '';
        return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
      }

      function parseIsoFromSig(sig) {
        var parts = (sig || '').split('|');
        return /^\d{4}-\d{2}-\d{2}$/.test(parts[1] || '') ? parts[1] : '';
      }

      function parseTimeFromSig(sig) {
        return (sig || '').split('|')[2] || '';
      }

      function normalizeDate(datePropInput, selectionSig) {
        var iso = parseIsoFromSig(selectionSig && selectionSig.value || '');
        if (iso) return iso;
        var human = datePropInput && datePropInput.value || '';
        if (human) { var d = new Date(human); if (!isNaN(d)) return toYMD(d); }
        return '';
      }

      function currentTime(timeSelect, selectionSig) {
        var v = timeSelect && timeSelect.value || '';
        if (v && v !== 'Please select...') return v;
        return parseTimeFromSig(selectionSig && selectionSig.value || '') || '';
      }

      function currentDay(dayPropInput, iso) {
        if (dayPropInput && dayPropInput.value) return dayPropInput.value;
        if (iso) { var d = new Date(iso + 'T00:00:00'); return d.toLocaleDateString(undefined, { weekday: 'long' }); }
        return '';
      }

      var PENDING = { iso: '', timeLabel: '', sig: '', userPicked: false };

      function firstRealTimeLabel(timeSelect) {
        if (!timeSelect) return '';
        var first = Array.from(timeSelect.options).find(function (o) {
          return o && !o.disabled && o.value && !/select|choose|pick/i.test(o.textContent || '');
        });
        return first ? (first.getAttribute && first.getAttribute('data-label') || first.textContent || '').trim() : '';
      }

      function previewFirstTimeWithoutSelecting(timeSelect, iso) {
        if (PENDING.iso && PENDING.iso !== iso) { PENDING.timeLabel = ''; PENDING.userPicked = false; }
        var hasReal = timeSelect && timeSelect.selectedIndex >= 0 && !(isPlaceholderOption(timeSelect.options[timeSelect.selectedIndex]));
        if (hasReal) {
          var opt = timeSelect.options[timeSelect.selectedIndex];
          PENDING.timeLabel = (opt.getAttribute && opt.getAttribute('data-label') || opt.textContent || '').trim();
          PENDING.userPicked = true;
          return;
        }
        if (!PENDING.timeLabel) {
          PENDING.timeLabel = firstRealTimeLabel(timeSelect);
          PENDING.userPicked = false;
        }
      }

      function findSlotsLeftInWidget(scope) {
        if (!scope) return null;
        var selected = scope.querySelector('option:checked,[aria-pressed="true"],[aria-checked="true"],.is-selected,.selected,.active,input[type="radio"]:checked') || null;
        var candidates = [];
        if (selected) candidates.push(selected);
        var near = selected && selected.closest('label,li,div') || null;
        if (near && near !== selected) candidates.push(near);
        var ATTRS = ['data-left','data-remaining','data-available','data-availability','data-available-slots','data-slots-left','data-slots','data-qty','data-qty-left','data-available-count'];
        for (var c = 0; c < candidates.length; c++) {
          var el = candidates[c];
          if (!el) continue;
          for (var a = 0; a < ATTRS.length; a++) {
            var raw = el.getAttribute && el.getAttribute(ATTRS[a]);
            if (raw != null && String(raw).trim() !== '') {
              var n = Number(String(raw).trim());
              if (Number.isFinite(n)) return n;
            }
          }
          var txt = (el.getAttribute && el.getAttribute('data-label') || el.textContent || '').trim();
          var m = txt.match(/(\d+)\s*(?:left|remaining|slots?)/i);
          if (m) return Number(m[1]);
        }
        return null;
      }

      function findDailyLeftInWidget(scope) {
        if (!scope) return null;
        var selectedDay = scope.querySelector('[aria-selected="true"],[aria-current="date"],.is-selected,.selected,.active,[data-selected="true"]') || null;
        var candidates = [];
        if (selectedDay) candidates.push(selectedDay);
        var near = selectedDay && selectedDay.closest('button,li,div,label') || null;
        if (near && near !== selectedDay) candidates.push(near);
        var ATTRS = ['data-day-left','data-day-remaining','data-left','data-remaining','data-available','data-availability','data-available-slots','data-slots-left','data-slots','data-qty','data-qty-left','data-available-count'];
        for (var c = 0; c < candidates.length; c++) {
          var el = candidates[c];
          for (var a = 0; a < ATTRS.length; a++) {
            var raw = el.getAttribute && el.getAttribute(ATTRS[a]);
            if (raw != null && String(raw).trim() !== '') {
              var n = Number(String(raw).trim());
              if (Number.isFinite(n)) return n;
            }
          }
          var txt = (el.getAttribute && el.getAttribute('data-label') || el.textContent || '').trim();
          var m = txt.match(/(\d+)\s*(?:left|remaining)/i);
          if (m) return Number(m[1]);
        }
        return null;
      }

      function readSlotsLeft(timeSelect) {
        if (!timeSelect) return null;
        var opt = timeSelect.options && timeSelect.options[timeSelect.selectedIndex] || null;
        if (!opt || isPlaceholderOption(opt)) return null;
        return parseSlotsLeftFromOption(opt);
      }

      function syncAll() {
        var els = getBuuntoEls();
        var iso = normalizeDate(els.datePropInput, els.selectionSig);
        var day = currentDay(els.dayPropInput, iso);
        try { setShip(iso); } catch (_) {}
        previewFirstTimeWithoutSelecting(els.timeSelect, iso);
        PENDING.iso = iso;
        PENDING.sig = buildBuuntoSignature(iso, PENDING.timeLabel || '');
        if (hiddenDate) hiddenDate.value = iso || '';
        if (hiddenDay) hiddenDay.value = day || '';
        if (hiddenTime) hiddenTime.value = PENDING.timeLabel || '';
        if (hiddenSig) hiddenSig.value = PENDING.sig || '';

        var left = null;
        if (els.slotsLeftInput) {
          var s = String(els.slotsLeftInput.value || '').trim();
          if (s !== '' && Number.isFinite(Number(s))) left = Number(s);
        }
        if (left === null) left = readSlotsLeft(els.timeSelect);
        if (left === null && !PENDING.userPicked) {
          var first = Array.from((els.timeSelect && els.timeSelect.options) || []).find(function (o) { return !isPlaceholderOption(o) && !o.disabled; });
          left = parseSlotsLeftFromOption(first);
        }
        if (left === null) left = findSlotsLeftInWidget(wrap);

        var hiddenLeft = rootEl.querySelector('#ppBuuntoLeft-' + sectionId);
        if (hiddenLeft) hiddenLeft.value = (typeof left === 'number' && Number.isFinite(left)) ? String(left) : '';

        var dayLeftNum = findDailyLeftInWidget(wrap);
        var hiddenDayLeft = rootEl.querySelector('#ppBuuntoDayLeft-' + sectionId);
        if (hiddenDayLeft) hiddenDayLeft.value = (typeof dayLeftNum === 'number' && Number.isFinite(dayLeftNum)) ? String(dayLeftNum) : '';

        var leftEl = rootEl.querySelector('#ppDateLeft-' + sectionId);
        if (leftEl) {
          var display = Number.isFinite(dayLeftNum) ? dayLeftNum : left;
          if (Number.isFinite(display) && (iso || '') !== '') {
            leftEl.hidden = false;
            leftEl.textContent = Number.isFinite(dayLeftNum) ? '\u00B7 ' + display + ' left today' : '\u00B7 ' + display + ' left';
          } else {
            leftEl.hidden = true;
            leftEl.textContent = '';
          }
        }
        try { updateSlotChip(); } catch (_) {}
      }

      async function commitPendingSelectionToBuunto() {
        var els = getBuuntoEls();
        var iso = PENDING.iso || (hiddenDate && hiddenDate.value) || '';
        var label = PENDING.timeLabel || (hiddenTime && hiddenTime.value) || '';
        if (!iso) return false;
        var hasReal = els.timeSelect && els.timeSelect.selectedIndex >= 0 && !(isPlaceholderOption(els.timeSelect.options[els.timeSelect.selectedIndex]));
        if (els.timeSelect && !hasReal && label) {
          var match = Array.from(els.timeSelect.options).find(function (o) {
            if (!o || o.disabled || !o.value) return false;
            var txt = (o.getAttribute && o.getAttribute('data-label') || o.textContent || '').trim();
            return txt === label;
          }) || Array.from(els.timeSelect.options).find(function (o) { return !isPlaceholderOption(o) && !o.disabled; });
          if (match) {
            els.timeSelect.value = match.value;
            els.timeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        var hardSig = buildBuuntoSignature(iso, label);
        if (els.selectionSig) {
          els.selectionSig.value = hardSig;
          els.selectionSig.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (hiddenSig) hiddenSig.value = hardSig;
        await new Promise(function (r) { setTimeout(r, 120); });
        try { syncAll(); } catch (_) {}
        var dLeft = dayLeft(), sLeft = slotLeft();
        if ((typeof dLeft === 'number' && dLeft <= 0) || (typeof sLeft === 'number' && sLeft <= 0)) {
          alert('That delivery window just sold out. Please pick another time.');
          return false;
        }
        return true;
      }

      window.__ppCommitBuunto = commitPendingSelectionToBuunto;

      ['buunto:selection-changed','buunto:time-selected','buunto:slot-selected','buunto:time-changed','buunto:slot-changed']
        .forEach(function (evt) { window.addEventListener(evt, syncAll, true); });

      if (wrap) {
        wrap.addEventListener('click', syncAll, true);
        wrap.addEventListener('input', syncAll, true);
        wrap.addEventListener('change', syncAll, true);
        var mo = new MutationObserver(syncAll);
        mo.observe(wrap, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });
      }
      syncAll();
      var tries = 0;
      var iv = setInterval(function () { tries++; syncAll(); if (tries > 40) clearInterval(iv); }, 250);
    })();

    // ================================================================
    // INIT: Show first step
    // ================================================================
    // Client-side sort tiles by price
    qa('.pp-grid').forEach(function (grid) {
      var tiles = Array.from(grid.querySelectorAll('.pp-tile'));
      tiles.sort(function (a, b) { return (parseInt(a.dataset.priceCents || '0', 10)) - (parseInt(b.dataset.priceCents || '0', 10)); });
      tiles.forEach(function (t, idx) {
        grid.appendChild(t);
        t.style.setProperty('--tile-index', idx);
      });
    });

    refreshUIFromSelections();
    showStep(0);

  } // end initBuilder

})();
